<template>
  <row>
    <column class="col-lg-2">
      <va-box title="Reports list" theme="box-info" :isBorder="true" widgetType="">
        <div slot="content">
          <h5>Select Report:</h5>
          <select class="form-control" v-model="reportKey" style="padding-left: 0px;">
            <option value=""></option>
            <option v-for="(item,index) in reports" :data="item" :key="index" :value="item['.key']">
              {{ item.Name }}
            </option>
          </select>
        </div>
      </va-box>
      <va-box :title="selectedElm.text ? selectedElm.text : 'New Item'" theme="box-info" :isBorder="true" widgetType="">
        <div slot="content">
          <input type="button" value="Add New Item" @click="addNewItem()" style="width: 100%; text-align: center;margin-bottom: 10px;" />
          <div style="margin-bottom: 10px;">
            Order:
            <select v-model="selectedIndex" @change="changeOrder()">
              <option v-for="n in countItems" :value="n - 1">{{n}}</option>
            </select>
          </div>
          <div style="margin-bottom: 10px;">
            Section:
            <select v-model="selectedSection" @change="changeSection()">
              <option value="header">header</option>
              <option value="body">body</option>
              <option value="page_footer">page_footer</option>
            </select>
          </div>
          <div v-if="selectedElmItems" v-for="item in selectedElmItems" style="margin-bottom: 10px;">
            {{item.Key}}: <b v-if="item.Type === 'range'">{{item.Value}}</b>
            <select v-if="item.Key === 'type'" v-model="item.Value">
              <option value="text">text</option>
              <option value="image">image</option>
              <option value="box">box</option>
            </select>
            <select v-else-if="item.Key === 'align'" v-model="item.Value" @change="itemUpdate(item)">
              <option value="left">left</option>
              <option value="center">center</option>
              <option value="right">right</option>
            </select>
            <input v-else :type="item.Type" v-model="item.Value" @change="itemUpdate(item)" :step="item.Range.Step" :min="item.Range.Min" :max="item.Range.Max" />
          </div>
        </div>
      </va-box>
    </column>
    <column class="col-lg-10" v-if="report">
      <div class="box box-info">
        <div class="box-header">
          <input type="text" class="pull-left form-control" style="width: 400px;" placeholder="Report Name" v-model="report.Name" />
          
          <!-- tools box -->
          <div v-for="item in orientationItems" class="pull-left tree-content tree--small left" style="margin-left: 20px; width: 130px;" @click="orientation=item.name">
            <i :class="['tree-checkbox', orientation===item.name?'checked':'']"></i>
            <span tabindex="-1" class="tree-anchor">
              <i :class="[item.icon, item.class]"></i>&nbsp;&nbsp; {{item.name}}
            </span>
          </div>
          <div class="pull-right box-tools">
            <button v-if="$root.isAdmin" type="button" class="btn btn-sm" data-widget="collapse" title="Edit Report" @click="saveReport">
              <i class="fa fa-save" style="font-size: 18px;"></i>
            </button>
            <button type="button" class="btn btn-sm" data-widget="collapse" title="Save as PDF" @click="cancelReport">
              <i class="fa fa-times" style="font-size: 18px;"></i>
            </button>
          </div>
          <!-- /. tools -->
        </div>
        <div class="box-body">
          <div slot="content" style="min-height: 450px; height: 100%; padding: 10px;">
            <div class="report-designer-container">

              <div style="width: 11in; height: 8.5in; background-color: #dfdfdf; position: relative;">

                <div style="background-color: #fafafa; position: absolute; top: 0.5in; left: 0.5in; bottom: 0.5in; right: 0.5in;">

                  <div v-for="(elm, index) in report.Definition.header.elements" class="reportHeader" @click="showElement(index, 'header', elm)">
                    <div v-for="handle in handles" :class="['handle', 'handle-' + handle]"
                         @mousedown.stop.prevent="handleDown(handle, $event)">
                    </div>
                    <div :id="'header' + 'Elm' + index" v-if="elm.type === 'box'" :style="GetStyle(elm)"></div>
                    <div :id="'header' + 'Elm' + index" v-if="elm.type === 'text'" :style="GetStyle(elm)">{{elm.text}}</div>
                    <img :id="'header' + 'Elm' + index" v-if="elm.type === 'image'" :src="elm.url" :style="GetStyle(elm)" />
                  </div>

                  <div class="reportBody" style="position: absolute; top: 1.3in; left: 0in; bottom: 0.50in; right: 0in;">
                    <div v-for="(elm, index) in report.Definition.body.elements" :id="'body' + 'Elm' + index" @click="showElement(index, 'body', elm)" :style="{ border: '1px #ccc dotted', position: 'absolute', top: elm.top + 'in', left: elm.left + 'in', width: elm.width + 'in', height: elm.height + 'in', backgroundColor: elm.background_color }">{{elm.text}}</div>
                  </div>

                  <div class="reportFooter" v-for="(elm, index) in report.Definition.page_footer.elements" v-show="report.Definition.page_footer.visible" @click="showElement(index, 'page_footer', elm)" :style="{ position: 'absolute', left: '0in', bottom: '0in', right: '0in', heigth: report.Definition.page_footer.height + 'in'}">
                    <div :id="'page_footer' + 'Elm' + index" v-if="elm.type === 'box'" :style="GetFooterStyle(elm)"></div>
                    <div :id="'page_footer' + 'Elm' + index" v-if="elm.type === 'text'" :style="GetFooterStyle(elm)">{{elm.text}}</div>
                    <img :id="'page_footer' + 'Elm' + index" v-if="elm.type === 'image'" :src="elm.url" :style="GetFooterStyle(elm)" />
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
      </div>
    </column>
  </row>
</template>
<script>
  import { db } from '../firebase'
  import Loading from 'vue-loading-overlay'
  import VABox from '../widgets/VABox'
  import VAInputGroup from '../components/VAInputGroup'
  import ReportBasic from '../reports/ReportBasic'
  import ReportCharts from '../reports/ReportCharts'
  import timeData from '../reports/data/time-data.json'
  // import timeDataSchema from '../reports/data/time-data-schema.json'
  // import reportToners from '../reports/data/reportsToners.json'
  export default {
    name: 'reports',
    components: {
      'loading': Loading,
      'va-box': VABox,
      'va-input-group': VAInputGroup,
      ReportBasic,
      ReportCharts
    },
    data () {
      return {
        fromDate: '',
        error: '',
        handles: ['tm', 'mr', 'bm', 'ml'],
        orientation: 'Portrait',
        orientationItems: [
          { name: 'Portrait', icon: 'fa fa-file-pdf-o' },
          { name: 'Landscape', icon: 'fa fa-file-pdf-o', class: 'rotate-flip' }
        ],
        hasReportHistory: false,
        reportHistory: { GenerateDate: '', PrintDate: '', ExportDate: '' },
        activeReport: 'Please Select Report...',
        hasData: false,
        isFullpage: false,
        reportKey: '',
        report: null,
        reportFile: '',
        reportPDF: '',
        filters: {
          dealerKey: ''
        },
        isLoading: false,
        reportData: [],
        reportDesigner: null,
        selectedPrevIndex: -1,
        selectedIndex: -1,
        selectedSection: '',
        countItems: 0,
        selectedElm: {},
        index: 0,
        elmData: {

        },
        elementCss: {
          position: 'absolute',
          top: '0in',
          left: '0in',
          width: '2in',
          height: '0.5in',
          fontWeight: 'bold',
          backgroundColor: '',
          textAlign: 'left',
          border: '1px dotted rgba(0,0,0,0.5)',
          zIndex: 0,
          fontSize: '14px'
        },
        maxPos: {
          left: 0,
          top: 0
        }
      }
    },
    firebase: function () {
      // var vm = this
      let reportsPath = 'Reports'
      let reportsRef = db.ref(reportsPath)
      return {
        reports: reportsRef.orderByChild('OrderIndex')
      }
    },
    created () {
      this.$root.title = 'Reports'
      if (this.$root.isAdmin) {
        this.filters.dealerKey = ''
      } else if (this.$root.isDealer) {
        this.filters.dealerKey = this.$root.user['.key']
      } else if (this.$root.isCustomer) {
        console.log('Reports: created()')
        console.log('this.$root.isCustomer = ' + this.$root.isCustomer)
        console.log(this.$root.filter)
        this.filters.dealerKey = this.$root.filter.dealerKey
        console.log(this.filters)
      }
    },
    mounted () {
    },
    computed: {
      reportHistoryPath () {
        return 'ReportsHistory/' + this.filters.dealerKey + '_' + this.filters.customerKey + '_' + this.filters.siteKey + '_' + this.filters.year + this.filters.month
      },
      isUsageReport () {
        return (this.report && this.report.Name === 'Printers Usage')
      },
      selectedElmItems () {
        if (this.selectedElm) {
          let items = []
          const keys = Object.keys(this.selectedElm)
          for (let i = 0; i < keys.length; i++) {
            let key = keys[i]
            let type = 'text'
            let range = { Step: 0, Min: 0, Max: 0 }
            let currentType = typeof this.selectedElm[key]
            switch (currentType) {
              case 'number': type = 'range'; break
              case 'string': type = 'text'; break
              case 'boolean': type = 'checkbox'; break
              default: type = 'text'; break
            }
            if (key.indexOf('color') >= 0) {
              type = 'color'
            }
            // :step="item.Range.Step" :min="item.Range.Min" :max="item.Range.Max"
            if (type === 'range') {
              if (key === 'fontsize') {
                range = { Step: 1, Min: 8, Max: 30 }
              } else {
                range = { Step: 0.05, Min: 0, Max: 10 }
              }
            }
            let item = {
              Key: key,
              Value: this.selectedElm[key],
              Type: type,
              Range: range
            }
            items.push(item)
          }
          items = items.sort(function (a, b) {
            try {
              // const nameA = a.Key.toUpperCase()
              // const nameB = b.Key.toUpperCase()
              const nameA = a.Type.toUpperCase()
              const nameB = b.Type.toUpperCase()
              if (nameA < nameB) return -1
              if (nameA > nameB) return 1
              return 0
            } catch (e) {
              return 0
            }
          })
          return items
        } else {
          return null
        }
      }
    },
    watch: {
      reportKey (val) {
        this.selectedIndex = -1
        this.selectedElm = {}
        this.loadReport()
      },
      selectedMonth (val) {
        console.log('watch: selectedMonth = ' + val)
        if (val) {
          this.filters.fromDate = this.$moment([this.filters.year, this.filters.month - 1]).format('YYYY-MM-DD')
          this.filters.toDate = this.$moment(this.filters.fromDate).endOf('month').format('YYYY-MM-DD')
          // this.checkReportHistory()
        }
      },
      reportHistoryPath (val) {
        console.log(val)
        this.checkReportHistory()
      },
      orientation (val) {
        let diff = this.report.Definition.page.paper_size.inches[0] - this.report.Definition.page.paper_size.inches[1]
        if (val === 'Landscape' && diff < 0) {
          let size0 = this.report.Definition.page.paper_size.inches[0]
          this.report.Definition.page.paper_size.inches[0] = this.report.Definition.page.paper_size.inches[1]
          this.report.Definition.page.paper_size.inches[1] = size0
          size0 = this.report.Definition.page.paper_size.mm[0]
          this.report.Definition.page.paper_size.mm[0] = this.report.Definition.page.paper_size.mm[1]
          this.report.Definition.page.paper_size.mm[1] = size0
        } else if (val === 'Portrait' && diff > 0) {
          let size0 = this.report.Definition.page.paper_size.inches[0]
          this.report.Definition.page.paper_size.inches[0] = this.report.Definition.page.paper_size.inches[1]
          this.report.Definition.page.paper_size.inches[1] = size0
          size0 = this.report.Definition.page.paper_size.mm[0]
          this.report.Definition.page.paper_size.mm[0] = this.report.Definition.page.paper_size.mm[1]
          this.report.Definition.page.paper_size.mm[1] = size0
        }
        this.$forceUpdate()
      }
    },
    methods: {
      rptElementId () {
        return this.$root.getGUID()
      },
      addNewItem () {
        let addToSection = this.selectedSection
        if (this.selectedSection === '') {
          addToSection = 'header'
        }

        let count = this.report.Definition[addToSection].elements.length
        let elmLeft = 0
        if (count > 0) {
          elmLeft = this.report.Definition[addToSection].elements[count - 1].left
        }

        let elmWidth = 1

        let newElm = {
          text: 'New Item',
          top: 0.05,
          left: elmLeft + elmWidth,
          width: elmWidth,
          height: 0.25,
          align: 'left',
          bold: false,
          fontsize: 12,
          wrap: false,
          text_color: '',
          background_color: '',
          type: 'text',
          style: ''
        }

        this.report.Definition[addToSection].elements.push(newElm)
        this.showElement(count, addToSection, newElm)
      },
      itemUpdate (item) {
        console.log(item.Value)
        /*
        this.selectedIndex
        this.selectedSection
        this.selectedElm
        */
        console.log(this.selectedSection)
        console.log(this.selectedIndex)
        console.log(item.Key)
        // console.log(this.report.Definition[this.selectedSection])
        console.log(this.report.Definition[this.selectedSection].elements[this.selectedIndex])
        let newValue = item.Value
        switch (item.Type) {
          case 'range': newValue = Number(item.Value); break
          case 'string': newValue = item.Value; break
          case 'boolean': newValue = item.Value; break
          case 'color': newValue = item.Value; break
          default: newValue = item.Value; break
        }
        this.report.Definition[this.selectedSection].elements[this.selectedIndex][item.Key] = newValue
        this.$forceUpdate()
      },
      showElement (index, section, elm) {
        let id = section + 'Elm' + index
        this.selectedPrevIndex = index
        this.selectedIndex = index
        this.selectedSection = section
        this.countItems = this.report.Definition[this.selectedSection].elements.length
        // this.selectedElm = elm
        this.selectedElm = {
          id: id,
          text: elm.text,
          top: elm.top,
          left: elm.left,
          width: elm.width,
          height: elm.height ? elm.height : 0.25,
          align: elm.align ? elm.elign : 'left',
          bold: elm.bold ? elm.bold : false,
          fontsize: elm.fontsize ? Number(elm.fontsize) : 12,
          wrap: elm.wrap ? elm.wrap : false,
          text_color: elm.text_color,
          background_color: elm.background_color,
          type: elm.type,
          style: elm.style ? elm.style : ''
        }
      },
      changeOrder () {
        console.log(this.selectedPrevIndex)
        console.log(this.selectedIndex)
        let elm = this.report.Definition[this.selectedSection].elements[this.selectedPrevIndex]
        if (this.selectedPrevIndex < this.selectedIndex) {
          for (let i = this.selectedPrevIndex; i < this.selectedIndex; i++) {
            // let currentElm = this.report.Definition[this.selectedSection].elements[i]
            let movingElm = this.report.Definition[this.selectedSection].elements[i + 1]
            // movingElm.top = currentElm.top
            movingElm.left = movingElm.left - elm.width
            // movingElm.width = currentElm.width
            // movingElm.height = currentElm.height
            this.report.Definition[this.selectedSection].elements[i] = movingElm
          }
          let replaceElm = this.report.Definition[this.selectedSection].elements[this.selectedIndex - 1]
          elm.left = replaceElm.left + replaceElm.width
        }
        if (this.selectedPrevIndex > this.selectedIndex) {
          for (let i = this.selectedPrevIndex; i > this.selectedIndex; i--) {
            // let currentElm = this.report.Definition[this.selectedSection].elements[i]
            let movingElm = this.report.Definition[this.selectedSection].elements[i - 1]
            // movingElm.top = currentElm.top
            movingElm.left = movingElm.left + elm.width
            // movingElm.width = currentElm.width
            // movingElm.height = currentElm.height
            this.report.Definition[this.selectedSection].elements[i] = movingElm
          }
          if (this.selectedIndex - 1 >= 0) {
            let replaceElm = this.report.Definition[this.selectedSection].elements[this.selectedIndex - 1]
            elm.left = replaceElm.left + replaceElm.width
          } else {
            elm.left = 0
          }
        }
        // elm.top = replaceElm.top
        // elm.left = replaceElm.left
        // elm.width = replaceElm.width
        // elm.height = replaceElm.height
        this.report.Definition[this.selectedSection].elements[this.selectedIndex] = elm
        this.$forceUpdate()
      },
      changeSection () {

      },
      GetStyle (elm) {
        let style = {}
        let isActive = (elm.id === this.selectedElm.id)
        style = {
          zIndex: isActive ? 20000 : 0,
          cursor: 'pointer',
          position: 'absolute',
          top: elm.top + 'in',
          left: elm.left + 'in',
          width: elm.width + 'in',
          height: elm.height + 'in',
          backgroundColor: elm.background_color,
          color: elm.text_color,
          fontSize: elm.fontsize + 'pt',
          fontWeight: elm.bold ? 'bold' : 'normal',
          textAlign: elm.align
        }
        return style
      },
      GetFooterStyle (elm) {
        let style = {}
        style = {
          position: 'absolute',
          left: elm.left + 'in',
          bottom: '0in',
          width: elm.width + 'in',
          height: elm.height + 'in',
          backgroundColor: elm.background_color,
          color: elm.text_color,
          fontSize: elm.fontsize + 'pt',
          fontWeight: elm.bold ? 'bold' : 'normal',
          textAlign: elm.align
        }
        return style
      },
      InitReportDesigner () {
        console.log('InitReportDesigner()...')
        let vm = this
        vm.reportData = []
        vm.reportData.push(
          {
            Logged: '20200830 12:52',
            MacAddress: '00-11-22-33-44',
            PrinterSerial: '00-11-22-33-44',
            IPAddress: '127.0.0.1',
            PageCount: 0,
            A4Black: 0,
            A4Color: 0,
            A3Black: 0,
            A3Color: 0
          }
        )

        /*
        let dataSource = [{
          id: 'report',
          data: vm.reportData
        }]
        */
        /*
        var data_sources = [{
          id: 'report',
          name: 'report',
          url: 'data/time-data.json',
          schema_url: 'data/time-data-schema.json'
        }];
        */

        // https://www.jsreports.com/examples/grouping-report-def.json

        /*
        // No need for designer temporarly .......
        var designer = new jsreports.Designer({
          embedded: true,
          container: $('.report-designer-container'),
          data_sources: dataSource,
          report_def: vm.report.Definition,
          layout: 'horizontal'
        })
        vm.reportDesigner = designer
        */
      },
      saveReport () {
        // let vm = this
        console.log('saveReport()...')
      },
      cancelReport () {
        // let vm = this
        console.log('cancelReport()...')
      },
      checkReportHistory () {
        let vm = this
        console.log('checkReportHistory()...')
        console.log('vm.reportHistoryPath = ' + vm.reportHistoryPath)
        db.ref(vm.reportHistoryPath).orderByKey().once('value', (snapReportHistory) => {
          const reportHistory = snapReportHistory.val()
          if (reportHistory) {
            console.log(reportHistory)
            vm.hasReportHistory = true
            vm.reportHistory = {
              GenerateDate: reportHistory.GenerateDate,
              PrintDate: reportHistory.PrintDate,
              ExportDate: reportHistory.ExportDate
            }
          } else {
            vm.hasReportHistory = false
          }
        })
        /*
        this.hasReportHistory = true
        this.reportHistory = { GenerateDate: '05/06/2019', PrintDate: '', ExportDate: '' }
        */
      },
      editReport () {
        console.log('editReport()...')
        let vm = this
        if (vm.reportKey) {
          vm.$router.push({ name: 'ReportDesigner', params: { reportKey: vm.reportKey } })
        } else {
          vm.$root.goto('ReportDesigner')
        }
      },
      editReportOLD () {
        var dataSource = [{
          id: 'time',
          name: 'Time',
          data: timeData,
          schema: this.report.Schema
        }]
        // Initialize a designer to modify the report definition
        var designer = new jsreports.Designer({
          data_sources: dataSource,
          images: [{
            name: 'ACME logo',
            url: 'images/acme-logo.png'
          }],
          report_def: this.report.Definition
        })

        console.log(designer)
      },
      loadReport () {
        console.log('loadReport()...')
        let vm = this
        vm.error = ''
        vm.report = null
        vm.filters.printerKey = ''
        try {
          $('.report-output').attr('src', '')
          for (let i = 0; i < vm.reports.length; i++) {
            if (vm.reports[i]['.key'] === vm.reportKey) {
              vm.report = vm.reports[i]
              break
            }
          }
          let diff = vm.report.Definition.page.paper_size.inches[0] - vm.report.Definition.page.paper_size.inches[1]
          if (diff > 0) {
            vm.orientation = 'Landscape'
          } else {
            vm.orientation = 'Portrait'
          }
          vm.InitReportDesigner()
        } catch (e) {
          vm.hasData = false
          vm.error = e.message
        }
      },
      runReport () {
        let vm = this
        console.log('runReport()...')
        console.log('runReport() >>> vm.filters.dealerKey = ' + vm.filters.dealerKey)
        vm.isLoading = true
        try {
          if (vm.report) {
            let childKey = ''
            let startAtValue = vm.fromDateInt
            let endAtValue = vm.toDateInt
            vm.filters.printerKey = vm.filters.printerKey.toUpperCase().trim()
            if (vm.$root.isDealer) {
              vm.filters.dealerKey = vm.$root.user['.key']
            }
            if (vm.filters.dealerKey === 'All' || !vm.report.Filters.DealerKey) {
              if (vm.filters.printerKey === '') {
                childKey = 'LoggedInt'
                startAtValue = vm.fromDateInt
                endAtValue = vm.toDateInt
              } else {
                childKey = 'DateMacKey'
                startAtValue = vm.filters.printerKey + '_' + vm.fromDateInt
                endAtValue = vm.filters.printerKey + '_' + vm.toDateInt
              }
            } else {
              if (vm.filters.customerKey === 'All') {
                if (vm.filters.printerKey === '') {
                  childKey = 'DateDealerKey'
                  startAtValue = vm.filters.dealerKey + '_' + vm.fromDateInt
                  endAtValue = vm.filters.dealerKey + '_' + vm.toDateInt
                } else {
                  childKey = 'DateDealerMacKey'
                  startAtValue = vm.filters.dealerKey + '_' + vm.filters.printerKey + '_' + vm.fromDateInt
                  endAtValue = vm.filters.dealerKey + '_' + vm.filters.printerKey + '_' + vm.toDateInt
                }
              } else {
                if (vm.filters.siteKey === 'All') {
                  console.log('runReport: vm.filters.siteKey = All')
                  console.log('vm.filters.dealerKey = ' + vm.filters.dealerKey)
                  console.log('vm.filters.customerKey = ' + vm.filters.customerKey)
                  if (vm.filters.printerKey === '') {
                    childKey = 'DateDealerCustomerKey'
                    startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.fromDateInt
                    endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.toDateInt
                    console.log('DateDealerCustomerKey startAtValue = ' + startAtValue)
                    console.log('DateDealerCustomerKey endAtValue = ' + endAtValue)
                  } else {
                    childKey = 'DateDealerCustomerMacKey'
                    startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.printerKey + '_' + vm.fromDateInt
                    endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.printerKey + '_' + vm.toDateInt
                  }
                } else {
                  if (vm.filters.printerKey === '') {
                    childKey = 'DateDealerCustomerSiteKey'
                    startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.fromDateInt
                    endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.toDateInt
                  } else {
                    childKey = 'DateDealerCustomerSiteMacKey'
                    startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.filters.printerKey + '_' + vm.fromDateInt
                    endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.filters.printerKey + '_' + vm.toDateInt
                  }
                }
              }
            }
            // DateMacKey
            // DealerCustomerSiteMacKey
            // DateDealerCustomerSiteMacKey
            console.log(childKey)
            console.log(startAtValue)
            console.log(endAtValue)

            if (vm.report.Method === 'GetErrorsByMac') {
              if (vm.filters.printerKey === '') {
                vm.isLoading = false
                vm.hasData = false
                vm.error = 'Please enter MAC Address!'
                return
              }
            }
            db.ref('History').orderByChild(childKey).startAt(startAtValue).endAt(endAtValue).once('value', (snapPrintersHistory) => {
              let printersHistory = []
              const data = snapPrintersHistory.val()
              if (data) {
                // console.log(data)
                const pritnerKeys = Object.keys(data)
                for (let i = 0; i < pritnerKeys.length; i++) {
                  let pKey = pritnerKeys[i]
                  let printer = data[pKey]
                  printer['.key'] = pKey
                  printersHistory.push(printer)
                }
                if (!vm.report.Definition.filters) {
                  vm.report.Definition.filters = []
                }
                if (!vm.report.Definition.inputs) {
                  vm.report.Definition.inputs = []
                }
                vm.report.Definition.page.paper_size.inches = [8.5, 11]
                vm.report.Definition.page.paper_size.mm = [216, 279]

                vm.report.Definition.page.paper_size.inches = [11, 8.5]
                vm.report.Definition.page.paper_size.mm = [279, 216]
                // vm.report.Definition.page_footer.elements[0] = {}

                // console.log(printersHistory)
                // Set Report Date
                if (vm.report.Definition.header.elements[2].text === 'Date') {
                  vm.report.Definition.header.elements[2].text = vm.$moment().format('DD/MM/YYYY')
                  // vm.report.Definition.header.elements[2].text = 'تاريخ التقرير' // Test Lang Ar
                  // vm.report.Definition.header.elements[2].text = 'תאריך הדוח' // Test Lang He
                  // vm.report.Definition.header.elements[2].text = 'Report Date' // Test Lang En
                }
                // customerKey
                let customerName = 'Unknown'
                let siteName = 'Unknown'
                if (vm.filters.customerKey === 'All') {
                  customerName = 'All Customers'
                  siteName = 'All Sites'
                } else {
                  for (let c = 0; c < vm.$root.customers.length; c++) {
                    if (vm.$root.customers[c].value === vm.filters.customerKey) {
                      customerName = vm.$root.customers[c].title
                      break
                    }
                  }
                  if (vm.filters.siteKey === 'All') {
                    siteName = 'All Sites'
                  } else {
                    for (let s = 0; s < vm.$root.sites.length; s++) {
                      if (vm.$root.sites[s].value === vm.filters.siteKey) {
                        siteName = vm.$root.sites[s].title
                        break
                      }
                    }
                  }
                }
                if (vm.report.Definition.header.elements[3].text === '#Customer #Site') {
                  vm.report.Definition.header.elements[3].text = '  Customer: ' + customerName + '          Site: ' + siteName + ''
                } else {
                  vm.report.Definition.header.elements[3].text = ''
                }
                console.log(JSON.stringify(vm.report.Definition.header))
                switch (vm.report.Method) {
                  case 'GetUsage': vm.exportUsageReport(vm, printersHistory); break
                  case 'GetCounters': vm.exportCountersReport(vm, printersHistory); break
                  case 'GetToners': vm.exportTonersReport(vm, printersHistory); break
                  case 'GetErrors': vm.exportErrorsReport(vm, printersHistory); break
                  case 'GetErrorsByMac': vm.exportErrorsByMacReport(vm, printersHistory); break
                  case 'GetStatus': vm.exportStatusReport(vm, printersHistory); break
                  default: vm.isLoading = false; vm.hasData = false; break
                }
              } else {
                vm.isLoading = false
                vm.hasData = false
                vm.error = 'Report has no data!'
                console.log('Report NO DATA !!')
              }
            })
          } else {
            vm.isLoading = false
            vm.hasData = false
            vm.error = 'Failed to create report!!'
          }
        } catch (e) {
          vm.isLoading = false
          vm.hasData = false
          vm.error = e.message
        }
      },
      exportUsageReport (vm, dataArr) {
        console.log('exportUsageReport()...')
        if (vm.report.Filters.Monthly && vm.selectedMonth === '') {
          vm.isLoading = false
          vm.hasData = false
          vm.error = 'Please select Month and Year!'
          return
        }
        // Group By MAC
        let grpHistory = dataArr.reduce(function (r, a) {
          r[a.MacAddress] = r[a.MacAddress] || []
          r[a.MacAddress].push(a)
          return r
        }, Object.create(null))

        // console.log(grpHistory)
        vm.reportData = []

        if (grpHistory) {
          let keys = Object.keys(grpHistory)
          for (let k = 0; k < keys.length; k++) {
            let key = keys[k]
            let printerArr = grpHistory[key]
            printerArr = printerArr.slice().sort(function (a, b) {
              return a.LoggedInt < b.LoggedInt ? -1 : 1
            })
            // console.log('console.log(printerArr)')
            console.log(printerArr)
            if (printerArr) {
              var firstItem = printerArr[0]
              var lastItem = printerArr[printerArr.length - 1]

              console.log('firstItem')
              console.log(firstItem)
              console.log('lastItem')
              console.log(lastItem)
              // for(let )
              vm.reportData.push(
                {
                  Logged: lastItem.Logged,
                  MacAddress: key,
                  PrinterSerial: lastItem.PrinterSerial,
                  IPAddress: lastItem.IPAddress,
                  PageCount: lastItem.PageCount - firstItem.PageCount >= 0 ? lastItem.PageCount - firstItem.PageCount : 'Error',
                  A4Black: lastItem.A4Black - firstItem.A4Black >= 0 ? lastItem.A4Black - firstItem.A4Black : 'Error',
                  A4Color: lastItem.A4Color - firstItem.A4Color >= 0 ? lastItem.A4Color - firstItem.A4Color : 'Error',
                  A3Black: lastItem.A3Black - firstItem.A3Black >= 0 ? lastItem.A3Black - firstItem.A3Black : 'Error',
                  A3Color: lastItem.A3Color - firstItem.A3Color >= 0 ? lastItem.A3Color - firstItem.A3Color : 'Error'
                }
              )
            }
          }
        }
        if (!vm.$root.isAdmin && vm.isUsageReport) {
          db.ref(vm.reportHistoryPath + '/ReportKey').set(vm.reportKey)
          db.ref(vm.reportHistoryPath + '/GenerateDate').set(vm.$moment().format('DD/MM/YYYY HH:mm'))
          db.ref(vm.reportHistoryPath + '/CustomerKey').set(vm.filters.customerKey)
          db.ref(vm.reportHistoryPath + '/SiteKey').set(vm.filters.siteKey)
          vm.checkReportHistory()
        }
        console.log(JSON.stringify(vm.reportData))
        vm.exportReport(vm, vm.reportData)
      },
      exportCountersReport (vm, dataArr) {
        console.log('exportCountersReport()...')
        if (vm.report.Filters.Monthly && vm.selectedMonth === '') {
          vm.isLoading = false
          vm.hasData = false
          vm.error = 'Please select Month and Year!'
          return
        }
        // Group By MAC
        let grpHistory = dataArr.reduce(function (r, a) {
          r[a.MacAddress] = r[a.MacAddress] || []
          r[a.MacAddress].push(a)
          return r
        }, Object.create(null))

        // console.log(grpHistory)
        vm.reportData = []

        if (grpHistory) {
          let keys = Object.keys(grpHistory)
          for (let k = 0; k < keys.length; k++) {
            let key = keys[k]
            let printerArr = grpHistory[key]
            printerArr = printerArr.slice().sort(function (a, b) {
              return a.LoggedInt < b.LoggedInt ? -1 : 1
            })
            // console.log('console.log(printerArr)')
            console.log(printerArr)
            if (printerArr) {
              var firstItem = printerArr[0]
              var lastItem = printerArr[printerArr.length - 1]

              console.log('firstItem')
              console.log(firstItem)
              console.log('lastItem')
              console.log(lastItem)
              // for(let )
              vm.reportData.push(
                {
                  Logged: lastItem.Logged,
                  MacAddress: key,
                  PrinterSerial: lastItem.PrinterSerial,
                  IPAddress: lastItem.IPAddress,
                  PageCount: lastItem.PageCount,
                  A4Black: lastItem.A4Black,
                  A4Color: lastItem.A4Color,
                  A3Black: lastItem.A3Black,
                  A3Color: lastItem.A3Color
                }
              )
            }
          }
        }
        vm.exportReport(vm, vm.reportData)
      },
      exportTonersReport (vm, dataArr) {
        console.log('exportTonersReport()...')
        // Group By MAC
        let grpHistory = dataArr.reduce(function (r, a) {
          r[a.MacAddress] = r[a.MacAddress] || []
          r[a.MacAddress].push(a)
          return r
        }, Object.create(null))

        // console.log(grpHistory)
        vm.reportData = []

        if (grpHistory) {
          let keys = Object.keys(grpHistory)
          for (let k = 0; k < keys.length; k++) {
            let key = keys[k]
            let printerArr = grpHistory[key]
            // console.log('console.log(printerArr)')
            // console.log(printerArr)
            if (printerArr) {
              // var firstItem = printerArr[0]
              var lastItem = printerArr[printerArr.length - 1]
              // for(let )
              vm.reportData.push(lastItem)
            }
          }
        }
        vm.exportReport(vm, vm.reportData)
      },
      exportErrorsReport (vm, dataArr) {
        console.log('exportErrorsReport()...')
        // Group By MAC
        let grpHistory = dataArr.reduce(function (r, a) {
          r[a.MacAddress] = r[a.MacAddress] || []
          r[a.MacAddress].push(a)
          return r
        }, Object.create(null))

        // console.log(grpHistory)
        vm.reportData = []

        if (grpHistory) {
          let keys = Object.keys(grpHistory)
          for (let k = 0; k < keys.length; k++) {
            let key = keys[k]
            let printerArr = grpHistory[key]
            // console.log('console.log(printerArr)')
            // console.log(printerArr)
            if (printerArr) {
              // var firstItem = printerArr[0]
              var lastItem = printerArr[printerArr.length - 1]
              // for(let )
              vm.reportData.push(lastItem)
            }
          }
        }
        vm.exportReport(vm, vm.reportData)
      },
      exportErrorsByMacReport (vm, dataArr) {
        console.log('exportErrorsByMacReport()...')
        vm.reportData = []
        vm.reportData = dataArr.sort((a, b) => (a.LoggedInt > b.LoggedInt) ? 1 : -1)
        vm.exportReport(vm, vm.reportData)
      },
      exportStatusReport (vm, dataArr) {
        console.log('exportStatusReport()...')
        vm.isLoading = false
        vm.hasData = false
        vm.error = 'Report Error: Failed to run report!'
      },
      renderReport (vm, reportData) {
        console.log('exportReport()...')
        let dataSource = [{
          id: 'report',
          data: reportData
        }]
        try {
          jsreports.render({
            report_def: vm.report.Definition,
            target: $('.report-output-render'),
            datasets: dataSource
          })

          vm.isLoading = false
          vm.hasData = true
        } catch (exp) {
          console.log('jsreports.export Error: ' + exp.message)
          vm.isLoading = false
          vm.hasData = false
          vm.error = 'Report Error: ' + exp.message
        }
      },
      exportReport (vm, reportData) {
        console.log('exportReport()...')
        let dataSource = [{
          id: 'report',
          data: reportData
        }]

        try {
          // vm.isLoading = false
          vm.hasData = true
          if (jsreports) {
            // console.log('jsreports: ' + jsreports)
            jsreports.export({
              format: 'pdf',
              report_def: vm.report.Definition,
              datasets: dataSource,
              outputHandler: function (pdfBlob) {
                vm.reportPDF = URL.createObjectURL(pdfBlob)
                $('.report-output').attr('src', URL.createObjectURL(pdfBlob))
                vm.isLoading = false
                vm.hasData = true
              }
            })
          } else {
            // location.reload()
            console.log('Report Error: [jsreports]')
            vm.isLoading = false
            vm.hasData = false
            vm.error = 'Report Error: [jsreports]'
          }
        } catch (exp) {
          console.log('jsreports.export Error: ' + exp.message)
          vm.isLoading = false
          vm.hasData = false
          vm.error = 'Report Error: ' + exp.message
        }
      },
      exportPDF () {
        let vm = this
        let dataSource = [{
          id: 'report',
          data: vm.reportData
        }]
        jsreports.export({
          format: 'pdf',
          report_def: vm.report.Definition,
          datasets: dataSource,
          outputHandler: function (pdfBlob) {
            const link = document.createElement('a')
            link.href = URL.createObjectURL(pdfBlob)
            link.download = vm.report.Name + '_From_' + vm.filters.fromDate + '_To_' + vm.filters.toDate + '.pdf'
            document.body.append(link)
            link.click()
            link.remove()
            window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true })
            if (!vm.$root.isAdmin && vm.isUsageReport) {
              db.ref(vm.reportHistoryPath + '/ExportDate').set(vm.$moment().format('DD/MM/YYYY HH:mm'))
              vm.checkReportHistory()
            }
          }
        })
      },
      exportCSV () {
        let vm = this
        let csv = vm.report.Name + '\n'
        let headers = []
        for (let i = 0; i < vm.report.Definition.body.elements.length; i++) {
          console.log(vm.report.Definition.body.elements[i].text)
          headers.push(vm.report.Definition.body.elements[i].text.replace('[', '').replace(']', ''))
        }
        csv += headers.join(',')
        csv += '\n'
        console.log(csv)
        vm.reportData.forEach(function (rowObj) {
          let row = []
          for (let i = 0; i < headers.length; i++) {
            row.push(rowObj[headers[i]])
          }
          csv += row.join(',')
          csv += '\n'
        })
        var hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
        hiddenElement.target = '_blank'
        hiddenElement.download = vm.report.Name + '.csv'
        hiddenElement.click()
        if (!vm.$root.isAdmin && vm.isUsageReport) {
          db.ref(vm.reportHistoryPath + '/ExportDate').set(vm.$moment().format('DD/MM/YYYY HH:mm'))
          vm.checkReportHistory()
        }
      },
      print () {
        const vm = this
        document.getElementById('iframReport').contentWindow.print()
        if (!vm.$root.isAdmin && vm.isUsageReport) {
          db.ref(vm.reportHistoryPath + '/PrintDate').set(vm.$moment().format('DD/MM/YYYY HH:mm'))
          vm.checkReportHistory()
        }
      },
      loadCustomers (dealerKey) {
        console.log('loadCustomers...')
        const vm = this
        // const sitesPath = 'Dealers/' + vm.$root.user['.key'] + '/Customers/' + customerKey + '/Sites'
        // const sitesRef = db.ref(sitesPath)
        vm.customers = []
        vm.customers = vm.$root.customers.filter(function (item) {
          return item.dealerKey === dealerKey
        })
        /*
        sitesRef.once('value').then(function (snapItems) {
          const data = snapItems.val()
          if (data) {
            console.log(data)
            const keys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < keys.length; i++) {
              let key = keys[i]
              let site = data[key]
              site['.key'] = key
              site['customerKey'] = customerKey
              vm.sites.push(site)
            }
          }
        })
        */
      },
      loadSites (customerKey) {
        console.log('loadSites...')
        const vm = this
        // const sitesPath = 'Dealers/' + vm.$root.user['.key'] + '/Customers/' + customerKey + '/Sites'
        // const sitesRef = db.ref(sitesPath)
        vm.sites = []
        vm.sites = vm.$root.sites.filter(function (item) {
          return item.customerKey === customerKey
        })
        /*
        sitesRef.once('value').then(function (snapItems) {
          const data = snapItems.val()
          if (data) {
            console.log(data)
            const keys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < keys.length; i++) {
              let key = keys[i]
              let site = data[key]
              site['.key'] = key
              site['customerKey'] = customerKey
              vm.sites.push(site)
            }
          }
        })
        */
      }
    }
  }
</script>
<style>
  .reportHeader {
    /*border: 2px dashed red;*/
  }
  .reportBody {
    border: 2px #cdcdcd dashed;
  }
  .reportFooter {
    /*border: 2px green dashed;*/
  }

  .divReportFilter {
    padding-bottom: 10px;
  }

  .reportView {
    z-index: 200;
    min-height: 29.7cm;
  }

  .page {
    background: white;
    display: block;
    position: relative;
    min-height: 0;
    margin: 0 auto;
    padding: 0;
    margin-top: 0.5cm;
    margin-bottom: 0.5cm;
    /*box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);*/
    /*page-break-before: always;
    page-break-before: always;
    page-break-after: always;
    break-before: always;
    break-after: always;
    page-break-after: always;*/
    /*page-break-inside: avoid;*/
    page-break-after: always;
    page-break-inside: avoid;
  }

    .page[size="A4"] {
      width: 21cm;
      height: 29.7cm;
      /*height: 31.0cm;*/
      /*position: relative;*/
    }

      .page[size="A4"][layout="portrait"] {
        width: 29.7cm;
        height: 21cm;
      }

    .page[size="A3"] {
      width: 29.7cm;
      height: 42cm;
    }

      .page[size="A3"][layout="portrait"] {
        width: 42cm;
        height: 29.7cm;
      }

    .page[size="A5"] {
      width: 14.8cm;
      height: 21cm;
    }

      .page[size="A5"][layout="portrait"] {
        width: 21cm;
        height: 14.8cm;
      }




  .jsreports-designer {
    font-family: helvetica, sans-serif;
    font-weight: normal;
    font-style: normal;
    z-index: 2;
    box-sizing: border-box;
  }

    .jsreports-designer input[type="radio"],
    .jsreports-designer input[type="checkbox"] {
      margin: 0;
    }

  .jsreports-designer {
    position: fixed;
    border-radius: 4px;
    border: 1px solid #aaa;
    transition: transform 300ms, -webkit-transform 300ms, opacity 300ms;
    visibility: visible;
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 1;
  }

    .jsreports-designer.before-fadein {
      transform: scale(0.9);
      -webkit-transform: scale(0.9);
      opacity: 0;
      visibility: hidden;
    }

  .jsr-designer-embedded {
    position: relative;
    width: 100%;
    height: 100%;
    border: none;
    transition: none;
    transform: none;
    -webkit-transform: none;
    visibility: visible;
  }

  .jsr-designer-popup {
    z-index: 1000;
  }

  .jsreports-designer .navbar {
    margin-bottom: 0;
    min-height: 0;
    border-width: 0;
  }

    .jsreports-designer .navbar .nav {
      padding-left: 0;
    }

  .jsr-style-root .navbar .nav > .active > a,
  .jsr-style-root .navbar .nav > .active > a:hover,
  .jsr-style-root .navbar .nav > .active > a:focus {
    box-shadow: none;
    -webkit-box-shadow: none;
    background: none;
    position: relative;
  }

    .jsr-style-root .navbar .nav > .active > a::after {
      content: '';
      display: block;
      position: absolute;
      left: 5px;
      right: 5px;
      bottom: 0;
      height: 3px;
      background: orange;
    }

  .jsreports-designer .jsr-designer-header,
  .jsreports-designer .palette,
  .jsreports-designer .preview {
    position: relative;
    box-shadow: 0 2px 3px rgba(0,20,40,0.2);
  }

  .jsreports-designer .palette {
    display: none !important;
  }

  .jsreports-designer .jsr-designer-left .left-pane-toggle-btn {
    box-sizing: border-box;
    position: absolute;
    top: 3px;
    right: 5px;
    z-index: 10;
    border: 1px solid #aaa;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    color: #777;
    font-size: 24px;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.15s, border-color 0.15s;
    font-weight: 700;
  }

    .jsreports-designer .jsr-designer-left .left-pane-toggle-btn::before {
      content: '';
      display: block;
      position: absolute;
      left: 6px;
      top: 5px;
      width: 8px;
      height: 12px;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAA6CAMAAADr99t8AAAAP1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACzJYIvAAAAFHRSTlMAB4bLzYcR56uzioF2YTXd0VFEJue46nIAAACYSURBVEjH3dC7DsMwCIVhCODWaZLeeP9n7dCBwRY5ijw0/edPBwn6Vpb7yrRXubi7MKDCZSpcrsLlKnccKnOrO+KqQ25zzE2gs8N7OtjJnzg9pTPUHb776Lpb4yphrnQUS8MYUguk5o7SVkFbNlBNHaWQkoFKf1TJmT9BT0hRhRS9UhVdARUuVOJCZS4U4IwIcDPtt9mbkj4NnUQbZ+rXAwAAAABJRU5ErkJggg==) 0 0 no-repeat;
      transform: rotate(180deg);
      background-size: 100%;
      opacity: 0.6;
    }

    .jsreports-designer .jsr-designer-left .left-pane-toggle-btn:hover {
      opacity: 1;
      background-color: rgb(142,68,173);
      border-color: rgb(142,68,173);
    }

      .jsreports-designer .jsr-designer-left .left-pane-toggle-btn:hover::before {
        filter: invert(100%);
        opacity: 1;
      }

  .jsreports-designer .jsr-designer-left.collapsed .left-pane-toggle-btn::before {
    left: 8px;
    transform: none;
  }

  .jsreports-designer .jsr-designer-header {
    z-index: 5;
    border-radius: 4px 4px 0 0;
    background: #fafafa;
    position: relative;
  }

  .jsreports-designer.jsr-designer-horizontal .jsr-designer-header {
    border-radius: 0;
    height: 100%;
  }

  .jsreports-designer .jsr-designer-header .navbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 33px;
  }

  .jsreports-designer .jsr-designer-header .header-panel {
    position: absolute;
    top: 33px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
  }

  .jsreports-designer .preview {
    background: #e3e3e3;
    padding: 10px;
    overflow: auto;
    position: absolute;
    left: 0;
    right: 0;
    box-shadow: inset 0 1px 3px rgba(0,20,40,0.1);
  }

    .jsreports-designer .preview .page {
      background-color: #fafafa;
      box-shadow: 0 2px 5px rgba(0,0,0,0.5);
      position: relative;
    }

      .jsreports-designer .preview .page.redrawing * {
        display: none;
      }

  .jsreports-designer .divider {
    border-color: #ddd;
    position: absolute;
  }

    .jsreports-designer .divider.horizontal {
      /*width: 100%;*/
      height: 5px;
      margin-top: -2px;
      background: none;
      border: none;
    }

      .jsreports-designer .divider.horizontal.margin {
        width: 100%;
      }

      .jsreports-designer .divider.horizontal.movable {
        cursor: row-resize;
      }

      .jsreports-designer .divider.horizontal:before {
        content: '';
        height: 0px;
        top: 2px;
        position: absolute;
        display: block;
        border-top: 1px solid #ddd;
        width: 100%;
      }

    .jsreports-designer .divider.section-divider.horizontal:before {
      border-top: 1px dashed #aaa;
    }

    .jsreports-designer .divider.left,
    .jsreports-designer .divider.right,
    .jsreports-designer .divider.column-divider,
    .jsreports-designer .divider.pivot-column-divider {
      top: 0;
      bottom: 0;
      width: 5px;
      border-left-width: 1px;
      border-left-style: solid;
      margin-left: -2px;
      z-index: 100;
    }

    .jsreports-designer .divider.margin.left,
    .jsreports-designer .divider.margin.right {
      border-left-style: dashed;
    }

    .jsreports-designer .divider.margin.horizontal:before {
      border-top-style: dashed;
    }

  .jsreports-designer .pivot-area-shading {
    position: absolute;
    top: 0;
    bottom: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAIAAACRuyQOAAAAsUlEQVRIib3Vuw2DQBgDYCcMkiorJFIWYsTswApULIJokBCng/sf9rm29MmVH+PvD3OmZbaXizz7MJ/X2yolGRg35RmTRGHaEotpSETmTuIylxKdqUsKpiKJmFLSMSdJyhySmtmlDgyAYV2/HRi4XiPDTMsclLwMYpsCTESKMW4pzPikDOOQkoxVyjMmicK0JRbTkIjMncRlLiU6U5cUTEUSMaWkY06SlDkkNbNLHRgAG/eJadIiQQ4UAAAAAElFTkSuQmCC);
    opacity: 0.1;
    z-index: 1;
  }

  .jsreports-designer .divider.pivot-column-divider {
    border-color: #8e44ad;
    border-left-style: solid;
    opacity: 0.7;
    cursor: col-resize;
  }

  .jsreports-designer .jsr-column-mask {
    background: rgba(20, 5, 0, 0.06);
    position: absolute;
  }

  .jsreports-designer .section-label {
    position: absolute;
    display: none;
    color: rgba(0, 80, 255, 0.6);
    font-size: 13px;
    z-index: 1;
    cursor: default;
  }

  .jsreports-designer .header-panel {
    padding: 15px;
    display: none;
  }

    .jsreports-designer .header-panel.active {
      display: block;
    }

  .jsr-new-element-palette .palette-item {
    display: block;
    padding: 5px 30px 5px 40px;
    background-repeat: no-repeat;
    background-size: 32px;
    background-position: 5px 0;
    cursor: pointer;
    position: relative;
    color: #555;
    border-bottom: 1px solid #eee;
    white-space: nowrap;
  }

    .jsr-new-element-palette .palette-item:last-child {
      border-bottom: none;
    }

    .jsr-new-element-palette .palette-item .jsr-designer-palette-icon {
      position: absolute;
      top: 5px;
      left: 10px;
      width: 20px;
      height: 20px;
      background-repeat: no-repeat;
      background-position: 0 0;
      background-size: 20px;
      /*opacity: 0.6;*/
    }

    .jsr-new-element-palette .palette-item:after {
      width: 0;
      height: 24px;
      border-left: 1px solid #aaa;
    }

    .jsr-new-element-palette .palette-item.chart {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAJUSURBVHhe7ZoxqE5hGMc/kpKUJIsYJDIoKRYlWWyyKhZJidUgiyyKsskiWSwGRUnqDgwWA4NBGZTBYrCIJOH3v/d76nE6x/3Od6/uc/j/6tf5zrnvOed5//f93u+9534jY4wxxhhjjDHGGGOMMWZpWDbeLpSf461YrGuWZPl4aybEgfXEgfXEgfXEgfXkfwjsMF6Ze1kHLSvCSqzB96i6SoVWNbDrGHU91oEqVAxsP0ZNn3ELlqFaYCvxNUZN57EU1QK7iFHPK1yBpagU2E78jqrlB+7DclQJTMukZxi13MCSVAnsDEYdH3AtlqRCYJtRn4ZRx0ksS4XA7mPU8FQHKrPUgR3DuP833IGlmTawc6hJ+sDs3nSsR81Xcf9LWJ5pAlNY+bwZ3It9uYlxjTe4CsuTOz4JzbCy91BrqUk4hPncgzgIctHzcRpz+za14LyLW7GL1fgW45w7OBhyZ//ECVQY0fYJbsfbGKvzrI7dwk3Y5DJGu0+4EQdD7mQXzbBeYF5YajR1BfcV9ahmA4o9mNudxUGRO9fGccxhaXJeh21oxOntmNuHWphexZfp2HMs98f1fORONTmCWhvFz/UEtO0t1kQTf1dwoUbZLhwcuROZZlhaL23DPii4B5jvEV7DQZI7ETTD+oi7cVq0RnuIcb13qE/KQRKdkMEXjGOae/TIeDFQcI9Qv5DB0hZY7GuU6V9dJtEVmCbso7N75je6Ajs199I0aQvswnj7T+Ev1PXEX0bpyd8YYZVZcH89wnriwIwxxhhjjDHGGGOMMcaYITAa/QI2mvXxDLm/KAAAAABJRU5ErkJggg==);
    }

    .jsr-new-element-palette .palette-item.text {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFjSURBVHhe7dnBKgVRAMbxISGKLEheQNnbYmMjLyArD+EJ7Gw9gEfBiiRlwdYj2NlY8J066nQbM/Np7syZ5v+rf6cw170fumoKAAAAAAAAAAAwCDPxbNt3PPvW+uubjScaYjATg5kYzNTVYF/qWu2rLbWk1tS2OlMvqs67Olc7al0tqk21qy7Vpxqs8C6ZdqKqLKsHNXndb88qfE2VYzV53WCkT/omfKCBA5VelxY+10T4Xul1reviT/IunnVe41nmNp513uI5NdP6x/W//vqtyOZ58i5pYjATg5kYzMRgJgYzMZiJwUwMZmIwE4OZGMzEYCYGMzGYicFMDGZiMBODmXIabCWeWctpsKr7jqvx7F1Og+3Fs8xRPBGFH9yjSm/Cpj2pOQUJY12osqHSrtS8Gq0FdajuVdlAZYW746dqQ43KhyobxCk8Ruf6ugUfXnAbOn/+Ob1LAgAAAAAAAABGpCh+ACzlWueLYilyAAAAAElFTkSuQmCC);
      background-size: 31px;
    }

    .jsr-new-element-palette .palette-item.box {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACrSURBVHhe7dhBCsJAEADB6P//rAgRQsjBhklUqLrsbZg0bA67AAAAAAAAAJzstp4THuu5NTm/OG2X6WDbeUdLX2m/y8i33teTDwkWTV/Jvcn5xV/8w162i34r1tspu7iSkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWDR5KuoJ+roteR23tHSV9rvMvKtrmQkWDR9Jfcm5xe/tAsAAAAAAABAsCxPs28QMv4y8jcAAAAASUVORK5CYII=);
    }

    .jsr-new-element-palette .palette-item.image {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALZSURBVHhe7ZlNqE1RGIYPA0RhgomL8lMoA4XUHZjIgAkpMwMzmZKBiRLKQEood6JkYGhgZkBSMpAJBgbyM/EzoRQS3vfs9Wm173eOe85e+2fxPvW01l737HW/8+211t57nZ4QQgghhBBCCCGEEEIIIbJgViir8iuUXafy950dSjFDlLARqWNKpuozFUlj0wgbkToTxis7yKfwvyZOhhG3lf0K58ImiP9vZepcw4YF+A3OK6ojswPugyvhQ3gWDsOLbWzaStgzuLGouqyBm+AKuBh+ga/hAbgXfoCX4YNQfwH5GY+kCUsFgzKNuK3saejBNfUQvATvQybBO9/zFbwKyxci/kxn8IKK22JfwgXQg6PpKHwOvXPNN5CjbTNcBZeGcjvcD+P+4/M6gxdU3Ga+h1uhx0H4CXJU3YE34Xfo9UOZtN3wb8TndAYvqLiNSbgGl0GPc/A23APnwF3wI4z7MI/DU5DJ5/FFOOzxKD63M3hBcXpxinDaMAmDWAe3FdU+HGkcWXz0uAJ3wh/Q+j8JCafdMchReZ0NA/Bia51UQW2BTA4X/LVsAFzE2e8jyOTchTETkHfLI/2j6aSKLSmpgroHDxfVP1jCOLIeQ07FMhzBFyAX/zKpYktKiqD4pTmFy1jCuK7dCnWOqjJcx3inLJMituTUGdRCyH6ZpPOhzuTNlKSx5bBb8RnyzYBT8S0bwLC3hFrJIWHkDOT7J++cZHUoGyeXhN0IpbE8lI2TS8IMuwtyXWuF3BJmLApl4+SWsCWhbGrzcRq5Jay1RBm5Jay1xwkjt4RtCKX3etQIdW5Rp4Z3yHdFtb+XPwW5ppn8e3w8H5KksXU5YXwv5A8ek3A95MPqoP00D4ujiYs5MgzKrAKTdAI+gXGf42h4ba1TNShuW3Mn4ieM+6qi4bWNTZenZCqSxpbrk35r1DHCuoxGWNMoYUIIIYQQQgghhBBCCCGE+Afp9X4DLigLMKWpcLcAAAAASUVORK5CYII=);
    }

    .jsr-new-element-palette .palette-item.barcode {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC/SURBVHhe7dDRScRAFEDRYduxCZvYfmzCJmzCKmzCJnQe2cB+emF/XM6BRybJZAJ3AQAAAADAc/jZ83Is19eez2O5PvbMu5m3ebB975nn49x379x/zv1Z8+2Ys16P5bruOffOv8f7nrl/mMvtyh8JFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCQYAAAAAAP/BWr/WUBRP2F+3ZQAAAABJRU5ErkJggg==);
    }

    .jsr-new-element-palette .palette-item.break {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD/SURBVHhe7dy9SsNQGIDh6G3p6CK4er+66ugF2ZSki0Pxhfxw4HngI6ddDrxtU0pKJgAY2eN6HM7LPF/L8lA/87wvyzE8zfMxz+86R7vte32xXq9PbOlhPW7pb6Q99rhn1/2H/byfRbBIsEiwSLBIsEiwSLBIsEiwSLBIsEiwSLBIsEiwSLBIsEiwSLBIsEiw6IjLbGdzme1MgkWCAfBvt/9i3Yz2OPMtCYzMj+/IST8SLBIsOuIctsce9+y6v3dYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYtEew53k+l+Wpvud5W5ZjcDusQTjNALCFaboA9IQq3Z6FRIQAAAAASUVORK5CYII=);
      background-size: 26px;
      background-position: 8px 2px;
    }

    .jsr-new-element-palette .palette-item.subreport {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADESURBVHhe7djRCoJQEEVR7f//2RAUhAw6oXdGWOtFego3zDQ0AQAAAABAjXl73mHZnvt37J9HueXdXtuTHwkWEiwkWKhs6S/Ltb8B8/zxKpZ+B4KFykZyACPZgWAhwUKChcqW/vEOO95Q/9xnJzfYytLvQLBQ2UgOYCQ7ECwkWEiwUNnSv+oO+3KDrSz9DgQLlY3kAEayA8FCgoUEC5Ut/Sv/D1ud3GOWfgeChcpGcgAj2YFgIcFCgoUEAwAAAACAJ5imN2UXJ0QZabXOAAAAAElFTkSuQmCC);
    }

    .jsr-new-element-palette .palette-item:hover {
      background-color: #eee;
      color: black;
    }

      .jsr-new-element-palette .palette-item:hover .jsr-designer-palette-icon {
        opacity: 1;
      }

  .jsreports-designer .jsr-designer-header h3 {
    font-size: 14px;
    font-weight: bold;
    color: rgb(155,153,187);
    margin: 0 0 0.5em 0;
    line-height: normal;
    letter-spacing: 1px;
  }

  .jsreports-designer .jsr-designer-header .settings-section {
    margin-bottom: 1.5em;
  }

  .jsreports-designer .jsr-designer-header .select2-container {
    /*min-width: 150px;
	margin-left: 5px;*/
  }

  .jsreports-designer .jsr-designer-header .indent {
    margin-left: 20px;
  }

  .jsreports-designer .jsr-designer-header label {
    display: inline;
    font-weight: normal;
  }

  .jsreports-designer .editable-row {
    position: relative;
    padding-right: 25px;
    padding-left: 15px;
    text-indent: -15px;
    border-radius: 3px;
    border: 1px solid transparent;
  }

    .jsreports-designer .editable-row .editable-row-buttons {
      position: absolute;
      top: 0;
      right: 4px;
    }

    .jsreports-designer .editable-row * {
      text-indent: initial;
    }

    .jsreports-designer .editable-row .select2-container,
    .jsreports-designer .editable-row .select2-container .select2-choice,
    .jsreports-designer .editable-row.inactive .select2-container .select2-choice > .select2-chosen,
    .jsreports-designer .editable-row.inactive .select2-container .select2-arrow {
      -webkit-transition: all 0.25s;
    }

    .jsreports-designer .editable-row.inactive .select2-container {
      min-width: 0;
    }

      .jsreports-designer .editable-row.inactive .select2-container .select2-choice,
      .jsreports-designer .editable-row.inactive input,
      .jsreports-designer .editable-row.inactive .readonly {
        border: none;
        padding: 0;
        background: none;
        color: #33a; /* #77b; */
        border-radius: 0;
        cursor: default;
        text-decoration: none;
      }

    .jsreports-designer .editable-row.inactive input {
      display: none;
    }

    .jsreports-designer .editable-row input[type="checkbox"] {
      display: inline;
      margin: 0;
    }

    .jsreports-designer .editable-row .readonly {
      display: none;
    }

    .jsreports-designer .editable-row.inactive .readonly {
      display: inline-block;
      vertical-align: middle;
      line-height: 26px;
    }

    .jsreports-designer .editable-row.inactive .select2-container .select2-choice > .select2-chosen {
      margin-right: 0;
      position: relative;
      top: 1px;
      text-indent: 0;
    }

    .jsreports-designer .editable-row.inactive .select2-container .select2-arrow,
    .jsreports-designer .editable-row.inactive .select2-container .select2-search-choice-close {
      display: none;
    }

  /*
.preview:hover .preview-element {
	border: 1px solid #ccc;
}
*/

  .jsreports-designer .preview-element {
    box-sizing: border-box;
    position: absolute;
    border: 1px solid #ccc;
    transition: border 0.2s;
    z-index: 1000;
    line-height: 1.2;
    cursor: default;
  }

    .jsreports-designer .preview-element.jsr-preview-element-box {
      z-index: 999;
    }

    .jsreports-designer .preview-element .jsr-text {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      cursor: default;
    }

    .jsreports-designer .preview-element .jsr-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 1px solid transparent;
      z-index: 999;
    }

    .jsreports-designer .preview-element.active {
      z-index: 1010;
      box-shadow: 0 0 0 6px rgba(33,150,243,0.2);
      cursor: move;
    }

    .jsreports-designer .preview-element.jsr-break .jsr-break-icon {
      background: white url(data:image/png;base64,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) 1px 1px no-repeat;
      position: absolute;
      top: -6px;
      left: 5px;
      border-radius: 3px;
      width: 20px;
      height: 12px;
      background-size: 19px;
    }

    .jsreports-designer .preview-element.jsr-break.active {
      box-shadow: 0 0 5px #2980b9;
    }

    .jsreports-designer .preview-element .jsr-resize-handle {
      position: absolute;
      display: none;
      z-index: 1000;
      box-sizing: content-box;
    }

    .jsreports-designer .preview-element.active .jsr-resize-handle {
      display: block;
    }

  .jsreports-designer .jsr-resize-handle {
    border: 2px solid rgba(0, 80, 255, 0.7);
    background-color: rgba(255,255,255,0.7);
    height: 6px;
    width: 6px;
    border-radius: 3px;
  }

  .jsreports-designer .jsr-resize-handle-b,
  .jsreports-designer .jsr-resize-handle-t {
    margin-left: -5px;
    left: 50%;
    cursor: ns-resize;
  }

  .jsreports-designer .jsr-resize-handle-l,
  .jsreports-designer .jsr-resize-handle-r {
    margin-top: -5px;
    top: 50%;
    cursor: ew-resize;
  }

  .jsreports-designer .jsr-resize-handle-t,
  .jsreports-designer .jsr-resize-handle-tr,
  .jsreports-designer .jsr-resize-handle-tl {
    top: -5px;
  }

  .jsreports-designer .jsr-resize-handle-b,
  .jsreports-designer .jsr-resize-handle-br,
  .jsreports-designer .jsr-resize-handle-bl {
    bottom: -5px;
  }

  .jsreports-designer .jsr-resize-handle-l,
  .jsreports-designer .jsr-resize-handle-bl,
  .jsreports-designer .jsr-resize-handle-tl {
    left: -5px;
  }

  .jsreports-designer .jsr-resize-handle-r,
  .jsreports-designer .jsr-resize-handle-br,
  .jsreports-designer .jsr-resize-handle-tr {
    right: -5px;
  }

  .jsreports-designer .jsr-resize-handle-tl,
  .jsreports-designer .jsr-resize-handle-br {
    cursor: nwse-resize;
  }

  .jsreports-designer .jsr-resize-handle-tr,
  .jsreports-designer .jsr-resize-handle-bl {
    cursor: nesw-resize;
  }

  .jsreports-designer .yui3-resize-knob .yui3-resize-handle-inner {
    background: none;
    height: 6px;
    width: 6px;
  }

  .jsr-section {
    border-bottom: 1px solid #ddd;
    position: absolute; /*relative;*/
    width: 100%;
    z-index: 1;
  }

    .jsr-section.jsr-page-background {
      top: 0;
      z-index: 0;
    }

  .jsr-element {
    position: absolute;
    z-index: 2;
  }

  .jsr-text {
    white-space: pre-line;
    word-wrap: break-word;
    overflow: hidden;
  }

    .jsr-text.jsr-markdown {
      white-space: normal;
    }

  .jsr-text-right {
    text-align: right;
  }

  .jsr-text-center {
    text-align: center;
  }

  .jsr-box {
    border: 1px solid transparent;
    z-index: 1;
  }

  .jsr-designer-image {
    opacity: 0.5;
    width: 100%;
  }

  .jsr-barcode:not(.qrcode),
  .jsr-barcode:not(.qrcode) img {
    width: 100%;
    height: 100%;
  }

  .jsreports-designer .preview-element.jsr-break {
    border: 0;
    left: 0 !important;
    width: 100% !important;
    border-top: 1px dashed rgba(0,0,0,0.5);
    background: transparent;
    cursor: move;
  }

  .jsr-toolbar-break-type,
  .jsr-toolbar-break-every {
    padding: 0 6px;
  }

    .jsr-toolbar-break-every input {
      width: 2em;
      text-align: right;
    }

  .jsr-toolbar.tool-container.tool-top,
  .jsr-toolbar.tool-container.tool-bottom {
    z-index: 1500 !important;
    border: none;
    box-shadow: 0 2px 3px rgba(0,20,40,0.2);
  }

  /*.jsr-toolbar-docked.tool-container.tool-top, 
.jsr-toolbar-docked.tool-container.tool-bottom {
	z-index: 1 !important;
}*/

  .jsr-toolbar .jsr-toolbar-text-bold .icon {
    width: 100%;
    height: 100%;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAJtSURBVHhe7do7axRRGMbx9RLvIAgqKRQLFVFsRD+AlSJYSiohXQobG7+AIDZWfgArO2sL4wUFg2BhqqCIN5SQQohREAULfZ7Nu7AM7+zO7GaOc948P/hzssUMOcNhduYkHRERERERERERERERycIGG1P5a2NVv9A39AN9Rq/QffQcrQu8YGvRG3QJhedNfpy42naisLxJj9s82oOSaMs97KuN/bhydqz+ONRddHn1x1iKq6PXIPvRDPqAvGN7nUbheBNlVXDFPUPe8ew2CsebKKvqMPqNvHM8ReF4E2V1vEDeOd6hxm20MSffbSziw23jcrxgW20s0gorsc/Gosc2huLde1hVJ5F3/E+U7OE1JW+yrAo+VpTd8K+jkLzJsmEOoifIO5aPE9tREm15NTprYz+uqEPoHLqANqGiWTSFVrqfAiqujlHjHtlVlOOXVi3e5Ov2CJ1A64J3AUbtNbqGkt2//gdv4uP2BZ1CSbTlpn/Pxn5b0C7E56tjaNBK4j3tPHrZ/RRIcXX0GoavQ/w2XEDe8WwRce8sFG+irKrN6A7yzsFuolC8SbI6eNF4w/fOs4RC8SbJ6rqCvPOwRh85cn3w4ztlmeM2NiLXCzZo72uvjY3I9YKVbSLSNhsbkesFm7TR0+jOa64XbNpGzycbQ/C+1VgdRxF3WL3zfESheJNkVR1BfHf0zsFuoFC8SbJB+KB6Bt1CZSuLvUWN71y0+Z9RaALtRsN+T758X0Rz3U+BFFfFWrSMkm3vpOZNeJweoAMoLG/So8T/deV2T3JtuYeV+YP4FyH2HvEd8qGNIiIiIiIiIiIiIpKxTucfj/Wni+c/mFIAAAAASUVORK5CYII=) 50% 50% no-repeat;
    background-size: 24px;
  }

  .jsr-toolbar .jsr-toolbar-text-italic .icon {
    width: 100%;
    height: 100%;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGtSURBVHhe7dqxLgVBFMbxS4KOTkWnoqIRnSfwBDrv42k8BxUVlY5GdCg4Z2c21s3ZlVXsfGP/v+TLjER1MnNmdu8uAAAAAAAAAAAARtq2fI7MrWVSq3lUsJ/HMWZdsIM8jnGXx8mwwkZayaOCLctGmjbjg2Wt+evbheUqTRsvlvc0nbcjS9Tk9yxFKW3Jrmh7vlnu07Qc1YL5Clt2k8eiairYdR6LqmlLTn6FqMWuJWr4JxYEzixRwdorR1GKWzK68fudzE/J4hQLdpjHLomG72pZYTT8Ht6nov7lfQ0BPwmjgvnJKUFtS0YX1mfLY5qWp1Yw+QurWsGihj/5O68hagWTvlKo8XddUcOP+loxSissWl1+u2dL9pB+JGqprzC5/qVUMNm3rF0qBdu07KTpD1L9S8mpJToh/fMBKSorLGr4/kj0lKY6VApWzYVVpWBVNHynUDB/BxY9dLPCevgjUfQDh+Rb1hIFW7f46dfm2LLsw/Jqaf/HP1SZrXNLdIUYyqVFQokVFl0hfiNzgS1RsL98ODfrX438k6Vo2w3FH50AAAAAAAAAAP/IYvEFL3RyrTGO1RcAAAAASUVORK5CYII=) 50% 50% no-repeat;
    background-size: 24px;
  }

  .jsr-toolbar .jsr-toolbar-text-underline .icon {
    width: 100%;
    height: 100%;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGRSURBVHhe7dlPKwVxFIfxSyIpWdnYiKIsWCEbCxtvwtYbUBbeAhsb5TVY2shG2VrYWUuyoeRPFqT4njpTv27KPcPMvTPzfOrplMzUnGbm1r0tAAAAAAAAAADq70B9Jf3VkcrOdW9/KEO/T3SIhQWxsCAWFsTCglhYEAsLYmFBLCyIhQWxsCAWFsTCglhYEAsLYmFBLCyIhQVVeWFDPs2Dz8KVubB3n5lRn3mlx7efuzBlLuzFZ2bcZ17p8c8+C1fmwtofmzmfeU37NLV8JC99ZhZ95jGr0nfYuc9asQtMf5e8VgMqjx2VnmtB1dKxSi90U0WNqBuVneNK1da6Shf2qmZUxJ5Kz7Gtau1MpRd8p1bVb+zOOlTpsfZYj6lam1RvKr1w60RtqAk1rIxNuwO31K1K//9DLalGWFF2Z6ULiPSo1lSjTKn2D4FOOlXzqrHssdpVF+pT/bQk+yTcV8uqq/p89opBZS/x7EX+5Nn7ClVU1B1mj1Ev+Pfrq/L3YV3BwoJYGAAAAAAAAAAAVdBqfQO8ZWiqNQLJpgAAAABJRU5ErkJggg==) 50% 62% no-repeat;
    background-size: 24px;
  }

  .jsr-toolbar .jsr-toolbar-conditional-properties .icon {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABiklEQVRYw+3Wv0tVcRjH8VeGPy4IoiLYYFPhIkKLf4AKDoZDNDhISFtIa0MNQZBLowgtgZtb4BA06CSkQ9FQuIiCTUYRuYig3uvyFQ5fuvfcezvnOHg/8OV7vvDcc97nOc/zfC4tXXfdzOm+AyjjLC2wLSeAMezgwVVl9iEqYa1jpFrgjcR1Jexfwv4Xu3iPTXRjHrN1AIygM3E+w1u8xJ9qP6rUWBu4jbt4nBJba/3Gk2Tt1VsD49gK8Z9CJppRB3rQXusTrIe9F/ciyF8B5gALmKjyoGPMJM5lrOAFDhshHsVelMYfGEzJ3nQi/gOG/6ei+7EdQXxGVwrAd0xm1VZ9+BZBLKcMolLWvT2EnxHEo6IHzBTOEwBHuFM0xKsoC1/zSHeaf3yMIFaLzsKt0M9JiGdREXblDTEZZvwlQDmM6cs23C/CDZ9GWSjjdSNumIXe/MN0TqLzKZbCPMlFi3m7YZqe437wiYbcMGuVMIe16M3P8S6YWCHK1A2bBcjUDZv5W17SUkt16AI/TYrMGB3l9wAAAABJRU5ErkJggg==) 50% 50% no-repeat;
    background-size: 21px;
    width: 100%;
    height: 100%;
    opacity: 0.6;
    cursor: pointer;
  }

  .jsr-toolbar .jsr-toolbar-text-font-family {
    line-height: 32px;
    vertical-align: middle;
  }

    .jsr-toolbar .jsr-toolbar-text-font-family select {
      width: 140px;
      margin: 0 2px 3px 3px;
    }

  .jsr-toolbar .jsr-toolbar-text-font-size {
    width: auto;
    text-decoration: none;
    color: #333;
    font-family: helvetica, sans-serif;
    line-height: 32px;
    vertical-align: middle;
    padding-right: 4px;
    font-size: 90%;
  }

  .jsr-toolbar .jsr-toolbar-text-wrap {
    padding: 0 4px;
  }

  .jsr-toolbar .jsr-toolbar-text-left .icon {
    width: 100%;
    height: 100%;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACCSURBVHhe7dkxCoAwEEXB6P3vrE2wMpAP0VWYabbOq3ZJAwAAAACAGlufqxx9Vlv9rsveJ5MECwkWEiwkGACM/PE0euzsmWGtCAkWEiwkWEgwABj58mlUegKNWCtCgoUECwkWEgwARv74a3TntTPKWhESLCRYSLCQYAAAAAAAlGjtBOKjBC35E9H/AAAAAElFTkSuQmCC) 50% 50% no-repeat;
    background-size: 21px;
  }

  .jsr-toolbar .jsr-toolbar-text-center .icon {
    width: 100%;
    height: 100%;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACISURBVHhe7doxCsQwDEVBZ+9/56RxtSDIB9lOMdOojV5lQQYAAAAAAJxxzdnlnvNr2vb8zclLgoUECwkWEgwAKt2nUWXXybR8H8+KkGAhwUKChQQDgMqu0+hf16m0/fs9K0KChQQLCRYSDAAqK0+L0z/XLdnNsyIkWEiwkGAhwQAAAAAAOGKMB5aLBC2R5MVvAAAAAElFTkSuQmCC) 50% 50% no-repeat;
    background-size: 21px;
  }

  .jsr-toolbar .jsr-toolbar-text-right .icon {
    width: 100%;
    height: 100%;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB+SURBVHhe7doxDsAgDARBkv//OWloLXESxClmGtdsdxIDAAAAAAB6XPOe8szbbds773lZJFhIsJBgIcEAoHJ6Gq34Yj6ZRl0ECwkWEiwkGABU/jCNKjsnk2nURbCQYCHBQoIBQOXradT1wc406iJYSLCQYCHBAAAAAABoMcYLMqMELTXEbr4AAAAASUVORK5CYII=) 50% 50% no-repeat;
    background-size: 21px;
  }

  div.jsreports-designer:before {
    position: absolute;
    left: -6px;
    top: -6px;
    right: -6px;
    content: '';
    background: rgba(0,0,0,0.2);
    bottom: -6px;
    border-radius: 6px;
    z-index: -1;
  }

  div.jsreports-designer.jsr-designer-embedded:before {
    display: none;
  }

  .jsr-toolbar.tool-container.tool-bottom > div {
    white-space: nowrap;
  }

  .jsr-toolbar.tool-container.tool-bottom .tool-item {
    float: none;
    display: inline-block;
    white-space: nowrap;
    width: auto;
    min-width: 44px;
    border: none;
    border-radius: 0;
    cursor: pointer;
  }

  .jsr-toolbar .tool-item:hover {
    background: #edbbb4;
  }

  .jsr-toolbar .tool-item.not-pressable:hover {
    background: none;
  }

  .jsr-toolbar.tool-container .tool-item {
    font-family: Helvetica, sans-serif;
    line-height: 35px;
    vertical-align: middle;
  }

  .jsr-toolbar .jsr-toolbar-chart-type,
  .jsr-toolbar .jsr-toolbar-chart-value-field,
  .jsr-toolbar .jsr-toolbar-chart-label-field {
    padding: 0 2px 0 6px;
  }

    .jsr-toolbar .jsr-toolbar-chart-type select,
    .jsr-toolbar .jsr-toolbar-chart-value-field select,
    .jsr-toolbar .jsr-toolbar-chart-label-field select {
      width: 125px;
      position: relative;
      top: 2px;
      padding-left: 4px;
    }

    .jsr-toolbar .jsr-toolbar-chart-type select {
      width: 70px;
    }

  .jsr-toolbar.tool-container.tool-bottom .tool-item .icon {
    height: 35px;
  }

  .jsr-toolbar.tool-container.tool-bottom {
    height: auto;
  }

    .jsr-toolbar.tool-container.tool-bottom .tool-items > div {
      border: none;
      clear: both;
      height: 35px;
    }

  .jsr-toolbar .jsr-toolbar-text-content,
  .jsr-toolbar .jsr-toolbar-item-text,
  .jsr-toolbar .jsr-toolbar-text-insertfield,
  .jsr-toolbar .jsr-toolbar-barcode-value {
    width: auto;
  }

  .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-text-content,
  .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-value,
  .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-item-text {
    width: 445px;
    padding: 3px;
    line-height: 20px;
    height: 29px;
    vertical-align: middle;
  }

  .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-value {
    width: 300px;
  }

  .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-type select {
    min-width: 130px;
  }

  .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-text-content,
  .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-value,
  .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-item-text {
    position: relative;
  }

    .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-text-content .input-wrap,
    .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-value .input-wrap,
    .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-item-text .input-wrap {
      position: absolute;
      top: 4px;
      left: 4px;
      bottom: 4px;
      right: 4px;
      border: 1px solid #aaa;
      background: white;
      border-radius: 3px;
      overflow: hidden;
    }

  .jsr-toolbar.tool-container.tool-bottom .tool-item .input-wrap.jsr-input-active {
    height: 200px;
    bottom: auto;
    box-shadow: 0 2px 15px rgba(0,0,0,0.2);
  }

  .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-text-content .input-wrap textarea,
  .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-value .input-wrap textarea,
  .jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-item-text .input-wrap textarea {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 2px 4px;
    border: 0;
    background: none;
    font-family: helvetica, sans-serif !important;
    font-size: 14px !important;
    line-height: 1.3;
  }

  .textcomplete-dropdown {
    background: white;
    list-style-type: none;
    padding: 2px 0;
    margin: 0;
    border: 1px solid #aaa;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);
    font-family: helvetica, sans-serif !important;
    overflow: scroll;
  }

    .textcomplete-dropdown li {
      padding: 2px 5px;
      cursor: pointer;
    }

      .textcomplete-dropdown li:hover,
      .textcomplete-dropdown li.active {
        background: #eee;
      }

  /*.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-text-content input:focus,
.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-value input:focus,
.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-item-text input:focus {
	outline: none !important;
}*/

  .jsr-element-toolbar-item-custom {
    padding: 0 0.5em;
  }

  .jsr-toolbar .jsr-toolbar-item-text label,
  .jsr-toolbar .jsr-toolbar-item-text .input-wrap {
    display: inline-block;
    line-height: 1.2;
  }

  .jsr-toolbar .jsr-toolbar-item-text label {
    margin-right: 0.5em;
  }

  .jsr-toolbar .jsr-toolbar-item-text .input-wrap {
    width: 300px;
  }

  .jsr-toolbar .jsr-toolbar-text-insertfield select {
    margin: 2px;
    width: 132px;
    border: 1px solid #aaa;
  }

  .jsr-toolbar .jsr-toolbar-barcode-type,
  .jsr-toolbar .jsr-toolbar-barcode-show-value {
    padding: 0 8px;
  }

  .jsr-toolbar .tool-item {
    height: 35px;
  }

  .jsr-toolbar.tool-container {
    background: #fafafa;
    border-radius: 3px;
    position: absolute;
  }

  /*
.jsr-toolbar.jsr-toolbar-docked.tool-container {
	border-radius: 0;
	box-shadow: none;
}
*/

  .palette-item.jsr-drag-proxy {
    border: 1px solid #aaa;
    border-radius: 0;
    width: 100px;
    height: 40px;
    z-index: 10000;
    background-repeat: no-repeat;
  }

    .palette-item.jsr-drag-proxy.break {
      height: 0px;
      border: 0;
      border-top: 1px solid #aaa;
    }

      .palette-item.jsr-drag-proxy.break:before,
      .palette-item.jsr-drag-proxy.break:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        height: 7px;
        top: -4px;
        width: 0;
        border-left: 1px solid #aaa;
      }

      .palette-item.jsr-drag-proxy.break:after {
        left: auto;
        right: 0;
      }

  .jsr-toolbar.tool-container.tool-bottom .tool-item.image-list {
    height: 150px;
    width: 350px;
    background: #f0f0f0;
    vertical-align: top;
    overflow: auto;
    cursor: pointer;
  }

  .jsr-toolbar.jsr-toolbar-docked.tool-container.tool-bottom .tool-item.image-list {
    height: 110px;
    width: 100%;
    white-space: nowrap;
  }

  .jsr-toolbar.tool-container .image-list .image-item {
    float: left;
    margin: 8px 5px 5px 5px;
    text-align: center;
    width: 70px;
  }

  .jsr-toolbar.tool-container .image-list .thumbnail {
    margin-left: 5px;
    border-radius: 0;
    width: 60px;
    height: 60px;
    background-size: contain;
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.25);
    background-repeat: no-repeat;
    background-position: 50% 50%;
  }

  .jsr-toolbar.tool-container .image-list .caption {
    margin-top: 3px;
    width: 80px;
    overflow: hidden;
    white-space: normal;
    line-height: 1.2em;
    height: 2.4em;
  }

  .jsr-toolbar.tool-container.tool-bottom.jsr-toolbar.jsr-toolbar-docked {
    border-left: none;
    border-right: none;
  }

  .jsr-toolbar.jsr-toolbar-docked .arrow,
  .jsr-toolbar.jsr-toolbar-docked .arrow-bdr {
    display: none;
  }

  .jsr-toolbar.jsr-toolbar-docked.tool-container.tool-bottom .tool-item {
    float: left;
    display: block;
  }

  .jsreports-designer .navbar .nav > li > a {
    padding: 6px 15px;
  }

  .jsr-designer-toolbar {
    background-color: #fafafa;
    background-image: -moz-linear-gradient(top,#fff,#f2f2f2);
    background-image: -webkit-gradient(linear,0 0,0 100%,from(#fff),to(#f2f2f2));
    background-image: -webkit-linear-gradient(top,#fff,#f2f2f2);
    background-image: -o-linear-gradient(top,#fff,#f2f2f2);
    background-image: linear-gradient(to bottom,#fff,#f2f2f2);
    background-repeat: repeat-x;
    border: 1px solid #d4d4d4;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff',endColorstr='#fff2f2f2',GradientType=0);
    -webkit-box-shadow: 0 1px 4px rgba(0,0,0,0.065);
    -moz-box-shadow: 0 1px 4px rgba(0,0,0,0.065);
    box-shadow: 0 1px 4px rgba(0,0,0,0.065);
  }

  .jsr-toolbar.tool-container.jsr-toolbar-docked {
    border-radius: 0;
  }

  .jsr-designer-toolbar .dropdown-menu {
    z-index: 1600;
  }

  .jsr-designer-toolbar,
  .jsreports-designer .navbar-inner {
    min-height: 32px;
    border-radius: 4px 4px 0 0;
    border: none;
    border-bottom: 1px solid #ccc;
    padding: 0 5px;
  }

  .jsr-toolbar-item-left {
    float: left;
  }

  .jsreports-designer .jsr-designer-header hr {
    margin: 10px 0;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #fafafa;
  }

  .jsreports-designer .jsr-designer-toolbar .jsr-btn,
  .jsreports-designer .jsr-designer-toolbar .jsr-btn-group {
    line-height: 16px;
    margin-top: 3px;
    height: 26px;
  }

  .jsreports-designer .jsr-designer-toolbar .designer-control-button,
  .jsreports-designer .jsr-designer-toolbar .jsr-toolbar-item-right {
    float: right;
    margin-left: 5px;
  }

  .jsreports-designer .input-name,
  .jsreports-designer .input-type,
  .jsreports-designer .input-default {
    margin-right: 10px;
  }

  .jsreports-designer .filters-list {
    margin-top: 8px;
  }

  .jsreports-designer .filter-field {
    width: 150px;
  }

  .jsreports-designer .filter-operator {
    width: auto;
    /*margin-left: 10px;*/
    margin-right: 10px;
  }

  .jsreports-designer .filter-operand {
    width: 250px;
    /*margin-left: 10px;*/
  }

  .jsreports-designer .filters-list {
    clear: both;
  }

  .jsreports-designer .filter-row.inactive .filter-field,
  .jsreports-designer .filter-row.inactive .filter-operator,
  .jsreports-designer .filter-row.inactive .filter-operand {
    width: auto;
  }

  .jsreports-designer button.add-filter {
    margin-top: 2px;
  }

  .jsreports-designer .filter-row {
    margin-bottom: 3px;
    padding-left: 15px;
    text-indent: -15px;
    position: relative;
  }

  .jsreports-designer .delete-row-icon {
    display: inline-block;
    margin-left: 10px;
    background: #ccc;
    color: #888;
    text-shadow: 0 1px 1px rgba(255,255,255,0.7);
    border-radius: 15px;
    width: 20px;
    text-align: center;
    line-height: 16px;
    padding: 1px 0 3px 0;
    cursor: pointer;
  }

  .jsreports-designer .editable-row.inactive .delete-row-icon {
    display: none;
  }

  .jsreports-designer .filter-row-preamble {
    width: 60px;
    position: absolute;
    left: 0;
    top: 0;
    text-align: right;
    margin-right: 10px;
    line-height: 26px;
  }

  .jsreports-designer .page-margins label {
    display: block;
  }

    .jsreports-designer .page-margins label .text {
      display: inline-block;
      width: 75px;
      text-align: right;
    }

  .jsreports-designer .page-margins input {
    width: 50px;
    margin-bottom: 5px;
    margin-right: 10px;
    text-align: right;
  }

  .jsreports-designer select.margin-units {
    width: 100px;
    margin-bottom: 0;
  }

  .jsreports-designer .select2-drop,
  .jsr-toolbar .select2-drop {
    min-width: 200px;
    z-index: 60000;
  }

  .jsreports-designer .input-row input {
    width: 150px;
  }

  .jsreports-designer .input-row span.input-name,
  .jsreports-designer .input-row span.input-type,
  .jsreports-designer .input-row span.input-default {
    display: inline-block;
    min-width: 100px;
    white-space: nowrap;
  }

  .jsreports-report-toolbar,
  .jsr-report .jsreports-report-toolbar {
    position: absolute;
    width: 100%;
    background: #eee;
    box-shadow: 0 1px 3px rgba(0,0,0,0.5);
    margin-bottom: 10px;
    font-family: Helvetica, sans-serif;
    z-index: 5;
  }

    .jsreports-report-toolbar .jsr-toolbar-buttons {
      margin: 6px 10px;
      width: 180px;
      float: right;
      text-align: right;
    }

    .jsreports-report-toolbar .jsreports-input {
      display: inline-block;
      margin: 2px 20px 2px 0;
      white-space: nowrap;
      vertical-align: middle;
    }

      .jsreports-report-toolbar .jsreports-input .select2-container {
        vertical-align: middle;
        margin-left: 0.5em;
      }

    .jsreports-report-toolbar .jsr-report-inputs {
      line-height: 30px;
      margin-right: 181px;
      margin: 6px 10px 0 10px;
    }

    .jsreports-report-toolbar .jsr-btn {
      font-size: 14px;
    }

  .jsreports-input input {
    width: 150px;
    margin-bottom: 0;
  }

  .jsreports-input.jsreports-input-boolean input {
    width: auto;
  }

  .jsreports-designer .jsreports-designer-trash {
    background: #333 url(data:image/png;base64,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) 27px 6px no-repeat;
    background-size: 13px;
    color: white;
    position: absolute;
    left: 50%;
    top: -50px;
    width: 110px;
    margin-left: -50px;
    text-align: center;
    padding: 6px 0 6px 12px;
    border-radius: 0 0 20px 20px;
    z-index: 60000;
    box-shadow: 0 2px 15px rgba(0,0,0,0.3);
    transition: top 500ms;
  }

    .jsreports-designer .jsreports-designer-trash.active {
      top: 0;
    }

  .jsreports-designer .delete-element-button {
    color: white;
    background: #aaa;
    border-radius: 3px 3px 0 0;
    width: 22px;
    text-align: right;
    padding: 0px 3px;
    white-space: nowrap;
    overflow: hidden;
    position: absolute;
    transition: width 250ms;
    font-size: 90%;
    cursor: pointer;
    z-index: 1400;
  }

    .jsreports-designer .delete-element-button:hover {
      background: #333;
      width: 60px;
    }

    .jsreports-designer .delete-element-button .delete-element-icon {
      display: inline-block;
      font-weight: bold;
      width: 16px;
      text-align: center;
    }

  .jsreports-designer .editable-row .editable-row-icon {
    /*display: inline-block;*/
    position: relative;
    top: 3px;
    margin-left: 8px;
    width: 16px;
    height: 16px;
    background: transparent none 50% 50% no-repeat;
    background-size: 16px 16px;
    opacity: 0;
    transition: opacity 200ms;
    cursor: pointer;
  }

    .jsreports-designer .editable-row .editable-row-icon.icon-check {
      background-image: url(data:image/png;base64,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);
    }

  .jsreports-designer .editable-row.inactive .editable-row-icon.icon-check {
    display: none;
  }

  .jsreports-designer .editable-row .editable-row-icon.icon-edit {
    display: none;
    background-image: url(data:image/png;base64,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);
  }

  .jsreports-designer .editable-row.inactive .editable-row-icon.icon-edit {
    /*display: inline-block;*/
    display: block;
  }

  .jsreports-designer .editable-row .editable-row-icon.icon-delete {
    background-image: url(data:image/png;base64,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);
    position: relative;
    padding-top: 1px;
  }

  .jsreports-designer .editable-row.inactive .editable-row-icon.icon-delete {
    /*display: inline-block;*/
    display: block;
  }

  .jsreports-designer .editable-row:hover {
    border-color: #aaa;
  }

    .jsreports-designer .editable-row:hover .editable-row-icon {
      opacity: 0.5;
    }

      .jsreports-designer .editable-row:hover .editable-row-icon:hover {
        opacity: 1;
      }

  /*.jsreports-designer .jsr-section-highlight {
	position: absolute;
	z-index: 1;	
	box-shadow: 0 0 3px rgba(50, 80, 180, 0.7);
	border-left: 3px solid lime;
	border-right: 3px solid lime;
}*/

  .jsreports-designer .grouping-row .group-header-footer-vis-cb {
    margin-left: 5px;
  }

  .jsreports-designer .preview-element .jsr-text {
    text-decoration: inherit;
    overflow: hidden;
  }

  .jsr-toolbar .jsr-toolbar-text-font-size select {
    width: 53px;
    margin: 0 0 4px 3px;
  }

  .jsr-toolbar .jsr-toolbar-box-cornerradius input {
    width: 30px;
  }

  .jsr-toolbar .jsr-toolbar-text-textcolor .sp-preview,
  .jsr-toolbar .jsr-toolbar-text-textcolor .sp-preview-inner {
    background: none !important;
  }

  .jsr-toolbar .jsr-toolbar-text-textcolor .sp-preview {
    text-align: center;
    border: none;
  }

  .jsr-toolbar .jsr-toolbar-text-textcolor,
  .jsr-toolbar .jsr-toolbar-text-backgroundcolor {
    padding: 0 2px;
  }

    .jsr-toolbar .jsr-toolbar-text-textcolor .sp-replacer,
    .jsr-toolbar .jsr-toolbar-text-backgroundcolor .sp-replacer,
    .jsr-toolbar .jsr-toolbar-box-bordercolor .sp-replacer,
    .jsr-toolbar .jsr-toolbar-box-backgroundcolor .sp-replacer {
      border: none;
      background: none;
    }

  .jsr-toolbar .jsr-toolbar-box-cornerradius input {
    margin: 0;
  }

  .jsr-toolbar .sp-dd {
    font-size: 15px;
    color: #333;
    line-height: 14px;
  }

  .jsr-toolbar .jsr-toolbar-box-bordercolor,
  .jsr-toolbar .jsr-toolbar-box-backgroundcolor,
  .jsr-toolbar .jsr-toolbar-box-cornerradius {
    padding: 0 3px 0 8px;
  }

  .jsr-toolbar .jsr-text-color-icon {
    display: inline-block;
    font-weight: bold;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -7px;
    width: 14px;
    height: 14px;
    vertical-align: middle;
    line-height: 16px;
    border-bottom: 4px solid #55f;
  }

  .jsreports-designer .editable-row-icon {
    position: relative;
  }

    .jsreports-designer .editable-row-icon .icon-label {
      position: absolute;
      top: -1px;
      right: 17px;
      font-size: 10px;
      text-align: center;
      overflow: visible;
      display: none;
      background: #f8f8f8;
      text-shadow: 0 0 1px #f0f0f0;
      padding: 0 4px;
    }

    .jsreports-designer .editable-row-icon:hover .icon-label {
      display: block;
    }

    .jsreports-designer .editable-row-icon.icon-delete .icon-label {
      background: #c0392b;
      color: white;
    }

  .jsreports-designer .select2-container {
    top: -1px;
  }

  body.jsr-designer-active {
    overflow: hidden;
  }

    /*body.jsr-designer-active > * {
	-webkit-filter: blur(6px);
	filter: blur(2px);
}

body.jsr-designer-active > .jsr-designer-container,
body.jsr-designer-active > .select2-drop,
body.jsr-designer-active > .tool-container {
	-webkit-filter: none;
	filter: none;
}
*/
    body.jsr-designer-active .datepicker-dropdown {
      z-index: 1500 !important;
    }

  .jsr-toolbar .sp-container .sp-palette {
    max-width: 200px;
  }

  .jsreports-designer .navbar-inner {
    padding-left: 5px;
  }

  .jsreports-preview-mask,
  .jsr-designer-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.3);
    z-index: 19000;
  }

  .jsr-designer-mask {
    position: fixed;
    z-index: 1;
    opacity: 0;
    transition: opacity 300ms;
  }

  .jsreports-logo {
    font-weight: bolder;
    text-shadow: 0 1px 0 white;
    color: #555;
    letter-spacing: -0.5px;
    font-size: 14px;
    /*padding: 5px 10px 0 7px;*/
    cursor: pointer;
    transition: color 200ms;
  }

    .jsreports-logo:hover {
      color: #57f;
    }

  .jsreports-preview-close-button {
    width: 24px;
    height: 24px;
    border-radius: 18px;
    border: 3px solid white;
    box-shadow: 0 0 1px black;
    background: #333;
    color: white;
    position: absolute;
    top: -25px;
    right: -25px;
    cursor: pointer;
    z-index: 20001;
    text-align: center;
    line-height: 20px;
    /*font-weight: bold;*/
    font-size: 24px;
  }

  .jsreports-preview-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
  }

  .jsreports-input-date input {
    width: 100px;
  }

  .jsreports-report-toolbar .jsr-toolbar-buttons > * {
    margin-left: 10px;
  }

  .jsreports-report-toolbar .jsr-save-dropdown-button {
    display: inline-block;
  }

    .jsreports-report-toolbar .jsr-save-dropdown-button .caret {
      margin-left: 5px;
    }

  .jsr-report-mask {
    display: none;
    background: rgba(255, 255, 255, 0.75);
    position: absolute;
    z-index: 10000;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }

    .jsr-report-mask .spinner {
      position: absolute;
      z-index: 10001;
      top: 50%;
      left: 50%;
      margin-left: -16px;
      margin-top: -16px;
      width: 32px;
      height: 32px;
      background: url(data:image/gif;base64,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);
    }

  .jsr-save-dropdown-button .caret {
    margin-top: 0;
  }

  .jsr-designer-horizontal .jsr-designer-left,
  .jsr-designer-horizontal .jsr-designer-right {
    vertical-align: top;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .jsr-designer-horizontal.jsr-overlay-left .jsr-designer-left {
    z-index: 1501;
    transition: width 0.25s cubic-bezier(0.005, 1.025, 0.085, 0.990);
  }

    .jsr-designer-horizontal.jsr-overlay-left .jsr-designer-left:not(.collapsed) {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 65000;
      box-shadow: 3px 0 0px 0px rgba(0,0,0,0.07);
    }

  .jsr-designer-horizontal .jsr-designer-left {
    background: #f8f8f8;
    overflow-x: visible;
    border-right: 1px solid #aaa;
  }

    .jsr-designer-horizontal .jsr-designer-left.collapsed {
      overflow-x: hidden;
      overflow-y: hidden;
    }

      .jsr-designer-horizontal .jsr-designer-left.collapsed .jsr-designer-header * {
        display: none;
      }

  /*.jsr-designer-horizontal .jsr-designer-left.collapsed .left-pane-toggle-btn {
	display: block;
}
*/
  .jsreports-designer .editable-row label {
    white-space: nowrap;
  }

  .jsr-report .jsr-image {
    background-size: contain;
    background-repeat: no-repeat;
  }

    .jsr-report .jsr-image img {
      width: 100%;
      height: auto;
      vertical-align: top;
    }

  .jsr-downloadify-download-mask {
    background: rgba(50, 50, 50, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .jsr-pdf-manual-download {
    position: absolute;
    width: 250px;
    left: 50%;
    margin-left: -125px;
    top: 33%;
    background: #fafafa;
    color: #444;
    text-align: center;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    padding: 15px;
  }

  .jsr-downloadify-button {
    margin-top: 10px;
  }

  .jsreports-designer .detail-column-count {
    width: 2em;
  }

  .jsreports-designer .jsr-column-clone-element {
    opacity: 0.5;
  }

  .jsr-print-only-section {
    display: none;
  }

  .jsr-report .jsr-filter-label {
    color: #777;
    margin-right: 0.5em;
  }

  .jsreports-designer .jsr-designer-header .btn {
    padding: 3px 8px;
  }

  .jsr-report {
    overflow: hidden;
  }

  .jsr-content-viewport {
    position: absolute;
    width: 100%;
    overflow: auto;
  }

  .jsr-toolbar.tool-container.tool-bottom .tool-items > div.jsr-toolbar-advanced {
    position: absolute;
    bottom: 0px;
    right: 8px;
    width: 32px;
    height: 32px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAHWlUWHRDb21tZW50AAAAAABDcmVhdGVkIHdpdGggR0lNUGQuZQcAAACeSURBVGje7dQxDgFBGEDhl3WKVbmAQrOcgANTrFsoHECUlChoaGwiE8YqmFl5XzLV5P3JZJIfJEmSJEnSX6mAGjgCB2AODLvST4EzcA3OCRjn3hfA5kncnFXmPaNI3JxBTn0RDChbfHE/cvfzPnzAvsWAXeQudU8P2Ea+b/1meOoegBlwebEFJh3o4b6ulg97ePHhHk/dS5IkSZK+7gbL1InPZTbgVwAAAABJRU5ErkJggg==);
    background-size: 22px;
    background-repeat: no-repeat;
    background-position: 50%;
    cursor: pointer;
    opacity: 0.4;
  }

    .jsr-toolbar.tool-container.tool-bottom .tool-items > div.jsr-toolbar-advanced:hover {
      opacity: 0.8;
    }

  .jsr-popup.jsr-property-editor {
    font-family: helvetica, sans-serif;
    font-size: 14px;
    width: auto;
    height: auto;
    max-width: 600px;
  }

    .jsr-popup.jsr-property-editor .jsr-popup-content {
      padding: 15px;
    }

  .jsr-property-editor .jsr-property-editor-scrollarea {
    width: 300px;
    max-height: 300px;
    overflow: auto;
  }

  .jsr-property-editor .jsr-property-editor-buttons {
    border-top: 1px solid #aaa;
    padding: 4px;
    text-align: right;
  }

  .jsr-property-editor .jsr-property-editor-ok {
    margin-right: 4px;
  }

  .jsr-property-editor .pgTable {
    border: none;
    border-spacing: 0;
    width: 100%;
  }

  .jsr-property-editor .pgGroupRow {
    font-weight: bold;
  }

    .jsr-property-editor .pgGroupRow td {
      padding-top: 8px;
      border-bottom: 1px solid #556069;
      color: #556069;
    }

    .jsr-property-editor .pgGroupRow:first-child td {
      padding-top: 0;
    }

  .jsr-property-editor .pgCell {
    padding: 0;
  }

    .jsr-property-editor .pgGroupCell,
    .jsr-property-editor .pgCell:first-child {
      padding: 0;
      white-space: nowrap;
    }

    .jsr-property-editor .pgCell:first-child {
      padding-right: 4px;
    }

  .jsr-property-editor .pgRow {
  }

  .jsr-property-editor .pgCell {
    border: none;
    position: relative;
  }

    .jsr-property-editor .pgCell:last-child {
      width: 60%;
    }

    .jsr-property-editor .pgCell input {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      border: none;
      font-family: helvetica, sans-serif;
      font-size: inherit;
      padding: 4px;
      background: none;
    }

      .jsr-property-editor .pgCell input[type=checkbox] {
        position: static;
      }

  .jsr-property-editor .pgTooltip {
    margin-left: 5px;
  }

  .jsr-snap-marker,
  .jsreports-snap-edge-highlight {
    position: absolute;
    display: none;
    background: rgba(41, 188, 255, 0.5);
    z-index: 1000;
  }

  .jsreports-snap-edge-highlight {
    display: block;
    background: rgba(41, 188, 255, 0.8);
  }

  .jsreports-snap-edge-highlight-horizontal {
    height: 3px;
    border-radius: 1.5px;
  }

  .jsreports-snap-edge-highlight-vertical {
    width: 3px;
    border-radius: 1.5px;
  }

  .jsr-snap-marker-vertical {
    width: 1px;
    /*border-left: 1px solid rgba(41, 188, 255, 0.5);*/
    height: 100%;
    top: 0;
    bottom: 0;
  }

  .jsr-snap-marker-horizontal {
    width: 100;
    height: 1px;
    /*border-top: 1px solid rgba(41, 188, 255, 0.8);*/
    left: 0;
    right: 0;
  }

  .jsreports-designer .preview-element.jsr-element-snapto {
    border: 1px solid rgba(41,188,255,1);
    box-shadow: 0 0 1px rgba(41,188,255,0.5);
  }

  .jsr-hint-bar {
    background: rgb(33,150,243);
    color: white;
    text-align: center;
    padding: 2px;
    position: absolute;
    bottom: 0;
    z-index: 1400;
    width: 100%;
  }

  .jsr-plugin-reportlist-select,
  .jsreports-designer button.jsr-plugin-reportlist-new {
    margin-right: 4px;
  }

  .jsreports-designer .select2-container.jsr-plugin-reportlist-select {
    top: 2px;
  }

  .jsr-plugin-reportlist .select2-container .select2-choice {
    height: 24px;
    line-height: 24px;
  }

  .jsr-plugin-reportlist-label {
    position: relative;
    top: 2px;
    vertical-align: middle;
    padding: 0 6px 0 4px;
    height: 24px;
    line-height: 24px;
  }

  .jsreports-designer .select2-container .select2-choice {
    text-decoration: none !important;
  }

  .jsr-select2-dropdown {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
  }

  .jsr-designer-empty {
    position: absolute;
    left: 0;
    right: 0;
    top: 33px;
    bottom: 0;
    background: #556;
  }

  .jsr-designer-empty-message {
    text-align: center;
    top: 50%;
    position: absolute;
    width: 100%;
    margin-top: -14px;
    font-size: 28px;
    font-weight: bold;
    opacity: 0.6;
    text-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);
  }

  .jsr-chart-error {
    font: bold 16px Helvetica, sans-serif;
    color: red;
  }

  .jsreports-designer .jsr-toolbar-subreport-edit button {
    margin: 2px 4px;
  }

  .jsreports-designer .jsr-toolbar-subreport-link {
    padding: 0 4px;
  }

  .jsreports-designer .preview-element.jsr-subreport .preview-element {
    overflow: hidden;
  }

  .jsreports-designer .jsr-subreport-preview {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 1;
  }

  .jsreports-designer .jsr-subreport-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
  }

  .subreport-indicator {
    display: inline-block;
    background: #77f;
    color: white;
    padding: 2px 12px;
    line-height: 24px;
    position: relative;
    top: 2px;
  }

  .jsr-unknown-jasper-element {
    overflow: hidden;
  }

  .jsr-table table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }

  /*.jsr-table td {
	border: 1px solid black;
}*/

  .jsr-table.preview-element .jsr-table-wrap {
    width: 100%;
    height: 100%;
  }

  .jsr-table.preview-element td,
  .jsr-table.preview-element th {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border: 1px solid #ddd;
  }

    .jsr-table.preview-element td::before,
    .jsr-table.preview-element th::before {
      content: '';
      display: inline-block;
      width: 0;
      height: 18px;
    }

  .jsr-report .jsr-spinner {
    height: 60px;
    width: 60px;
    margin: -36px auto 0 auto;
    position: relative;
    top: 50%;
    -webkit-animation: jsr-spinner-rotation .6s infinite linear;
    -moz-animation: jsr-spinner-rotation .6s infinite linear;
    -o-animation: jsr-spinner-rotation .6s infinite linear;
    animation: jsr-spinner-rotation .6s infinite linear;
    border: 6px solid rgba(0, 174, 239, 0.15);
    border-top: 6px solid rgba(0, 174, 239, 0.8);
    border-radius: 100%;
    overflow: hidden;
    z-index: 10001;
  }

  @-webkit-keyframes jsr-spinner-rotation {
    from {
      -webkit-transform: rotate(0deg);
    }

    to {
      -webkit-transform: rotate(359deg);
    }
  }

  @-moz-keyframes jsr-spinner-rotation {
    from {
      -moz-transform: rotate(0deg);
    }

    to {
      -moz-transform: rotate(359deg);
    }
  }

  @-o-keyframes jsr-spinner-rotation {
    from {
      -o-transform: rotate(0deg);
    }

    to {
      -o-transform: rotate(359deg);
    }
  }

  @keyframes jsr-spinner-rotation {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(359deg);
    }
  }

  /*.jsr-spinner .jsr-slice-clip,
.jsr-spinner .jsr-slice-clip2 {
    width: 60px;
    height: 60px;
    position: absolute;
    clip: rect(0, 30px, 60px, 0);
    animation: jsr-spinner-rotation 0.25s infinite linear;
    animation-direction: reverse;
}

.jsr-spinner .jsr-slice-clip2 {
    transform: rotate(180deg);
    animation: jsr-spinner-rotation 0.4s infinite linear;
    animation-direction: reverse;
}

.jsr-spinner .jsr-slice {
    content: "";
    position: absolute;
    width: 60px;
    height: 60px;
    border-radius: 30px 0 0 30px;
    background: #E1F5FE;
    transform: rotate(10deg);
    clip: rect(0px, 30px, 30px, 0px);
}

.jsr-spinner .jsr-slice-clip2 .jsr-slice {
    transform: rotate(0deg);
}*/

  .jsr-measure-sections {
    visibility: hidden;
  }

    .jsr-measure-sections .jsr-section {
      position: relative;
      width: 999999px;
      overflow: auto;
      height: auto !important;
      top: 0 !important;
    }

      .jsr-measure-sections .jsr-section.jsr-print-only-section,
      .jsr-measure-sections .jsr-section.jsr-page-background {
        position: absolute;
      }

    .jsr-measure-sections .jsr-element {
      position: relative;
      float: left;
      left: 0 !important;
    }

  .jsr-vrender .jsr-section {
    display: none;
  }

    .jsr-vrender .jsr-section.jsr-paged-in {
      display: block;
    }

  .jsr-line-horizontal {
    position: absolute;
    width: 100%;
    height: 0;
    border: 0;
  }

  .jsr-line-vertical {
    position: absolute;
    height: 100%;
    width: 0;
    border: 0;
  }

  .jsr-chart-line .dimple-axis-y .tick text,
  .jsr-chart-bar .dimple-axis-y .tick text {
    text-anchor: end !important;
  }

  .jsr-chart-render-container {
    display: block;
    position: absolute;
    left: -5000;
    opacity: 0;
  }

  .jsr-designer-subelement {
    position: absolute;
  }

  .jsr-dashboard {
    -webkit-perspective: 800;
  }

  .jsr-dashboard-tile.jsr-tile-before-show {
    transform: rotateY(-40deg) rotateX(30deg) translate3d(0, 0, -50px);
    transform-style: preserve-3d;
    opacity: 0;
  }

  .jsr-dashboard-tile {
    transition: transform 0.5s, opacity 0.5s;
    opacity: 1;
    transform: none;
  }

  .jsr-featherlight .featherlight-content {
    padding: 0 !important;
  }

    .jsr-featherlight .featherlight-content .jsreports-report-toolbar {
      padding-right: 25px;
    }

    .jsr-featherlight .featherlight-content .featherlight-close-icon {
      line-height: 40px;
      width: 30px;
    }

  .jsr-designer-image-dropzone {
    width: 90px;
    height: 90px;
    float: left;
    border: 2px dashed #aaa;
    margin: 8px 5px 5px 10px;
  }

  .jsr-toolbar.tool-container .tool-item .jsr-designer-image-dropzone {
    line-height: 1.2;
    overflow: hidden;
  }

  .jsr-designer-image-dropzone .dz-message {
    position: relative;
    top: 1.2em;
    white-space: normal;
  }

  .jsreports-report-toolbar .jsreports-input .select2-container-multi {
    min-width: 200px;
  }

  .jsr-table-cell-selected {
    outline: 4px solid rgba(0, 80, 255, 0.4);
  }

  .jsr-designer-grid {
    background-image: url(data:image/png;base64,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);
  }

  .jsr-table-column-resize-bar {
    position: absolute;
    top: 0;
    width: 5px;
    height: 100%;
    z-index: 10;
    cursor: ew-resize;
    display: none;
  }

  .jsreports-designer .jsr-table .jsr-table-column-tab {
    background: rgb(33,150,243);
    border-radius: 3px 3px 0 0;
    position: absolute;
    bottom: 100%;
    height: 16px;
    color: white;
    opacity: 0;
    text-align: center;
    font-size: 16px;
    line-height: 12px;
    transition: opacity 0.2s;
  }

  .jsreports-designer .jsr-table.jsr-column-tab-visible .jsr-table-column-tab {
    opacity: 1;
    cursor: pointer;
  }

  .jsr-column-menu-item {
    padding: 2px 6px;
    cursor: pointer;
    font-size: 14px;
  }

    .jsr-column-menu-item:hover {
      background: #eee;
    }

  .jsr-table.active .jsr-table-column-resize-bar {
    display: block;
  }

    .jsr-table.active .jsr-table-column-resize-bar:hover {
      background: rgba(0, 80, 255, 0.3);
    }

  .jsr-table.active .jsr-table-column-resize-bar-dragging {
    background: rgba(0,0,0,0.3);
  }

  .jsreports-designer .header-panel.data {
    padding: 0;
  }

  .jsr-data-section-accordion-header {
    height: 2em;
    line-height: 2em;
    border-top: 1px solid #ccc;
    padding: 0 10px;
    font-weight: bold;
    color: #666;
    cursor: pointer;
  }

    .jsr-data-section-accordion-header:first-child {
      border-top: none;
    }

  .jsr-accordion-icon {
    transition: transform 250ms;
    display: inline-block;
    cursor: pointer;
  }

  .jsr-accordion-header-open .jsr-accordion-icon {
    transform: rotateZ(90deg);
  }

  .jsr-data-section-accordion-pane-body {
    height: 0;
    overflow: auto;
    transition: height 300ms;
  }

  .jsreports-designer .header-panel .jsr-padding {
    padding: 15px;
  }

  .jsreports-designer .btn.jsr-add-data-section {
    margin-bottom: 5px;
  }

  /*
.jsr-text p,
.jsr-text ul,
.jsr-text li {
	margin: 0;
	padding: 0;
}
*/

  .jsr-text ul {
    padding-left: 0;
  }

  .jsr-text li {
    margin-left: 1em;
  }

  .jsr-popup {
    position: absolute;
    border-radius: 6px;
    background: #fafafa;
    box-shadow: 0 2px 6px rgba(0, 20, 40, 0.2);
    z-index: 9999;
    padding: 0;
    box-sizing: border-box;
    visibility: hidden;
    opacity: 0;
    margin-top: -8px;
    transition: margin-top 150ms, opacity 150ms;
    overflow: visible;
  }

  .jsr-popup-content {
    overflow: auto;
    border-radius: 6px;
    padding: 0;
    box-sizing: border-box;
  }

  .jsr-popup-transitioning {
    visibility: visible;
  }

  .jsr-popup-visible {
    visibility: visible;
    opacity: 1;
    margin-top: 0;
  }

  .jsr-popup-arrow {
    position: absolute;
    left: 15px;
    top: -7px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #ddd;
  }

    .jsr-popup-arrow::before {
      content: '';
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      top: 1px;
      left: -8px;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #fafafa;
    }

  .jsr-popup-placement-right .jsr-popup-arrow {
    transform: rotate(-90deg);
    top: 15px;
    left: -12px;
  }

  .jsr-new-element-button {
    position: absolute;
    left: 3px;
    top: 100px;
    width: 28px;
    height: 28px;
    border: 1px solid rgb(41,121,255);
    border-radius: 50%;
    background: white;
    text-align: center;
    font-size: 20px;
    line-height: 25px;
    color: #888;
    font-weight: 300;
    transition: opacity 0.15s, top 200ms;
    cursor: pointer;
    box-shadow: 0 1px 1px rgba(0, 10, 20, 0.2);
    z-index: 100;
  }

  .jsr-new-element-popup .jsr-popup-content {
    padding: 5px 0;
    background: #fafafa;
  }

  .jsr-new-element-button:hover {
    color: black;
  }

  .jsreports-designer .select2-arrow,
  .jsreports-designer .select2-container .select2-choice .select2-arrow {
    background: none;
    border: none;
    width: 25px;
    border-left: 1px solid #aaa;
  }

    .jsreports-designer .select2-container .select2-arrow b,
    .jsreports-designer .select2-container .select2-choice .select2-arrow b {
      width: 6px;
      height: 10px;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAA6CAMAAADr99t8AAAAP1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACzJYIvAAAAFHRSTlMAB4bLzYcR56uzioF2YTXd0VFEJue46nIAAACYSURBVEjH3dC7DsMwCIVhCODWaZLeeP9n7dCBwRY5ijw0/edPBwn6Vpb7yrRXubi7MKDCZSpcrsLlKnccKnOrO+KqQ25zzE2gs8N7OtjJnzg9pTPUHb776Lpb4yphrnQUS8MYUguk5o7SVkFbNlBNHaWQkoFKf1TJmT9BT0hRhRS9UhVdARUuVOJCZS4U4IwIcDPtt9mbkj4NnUQbZ+rXAwAAAABJRU5ErkJggg==) 0 0 no-repeat !important;
      background-size: 6px !important;
      transform: rotate(90deg);
      opacity: 0.7;
      position: relative;
      top: 8px;
      left: 8px;
    }

  .jsreports-designer .select2-container .select2-choice {
    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #f9f8f9), color-stop(0.2, #fcfbfc), color-stop(1, #fff));
    background-image: linear-gradient(top, #fff 0%, #fcfbfc 80%, #f9f8f9 100%);
    background-size: 100%;
    box-shadow: 0 2px 1px rgb(248, 248, 248);
  }

    .jsreports-designer .select2-container .select2-choice > .select2-chosen {
      margin-right: 34px;
    }

  .jsr-btn,
  .jsreports-designer .jsr-btn {
    border: 1px solid rgb(193, 184, 202);
    color: rgb(73, 62, 84);
    border-radius: 4px;
    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #f9f8f9), color-stop(0.2, #fcfbfc), color-stop(1, #fff));
    background-image: linear-gradient(top, #fff 0%, #fcfbfc 80%, #f9f8f9 100%);
    background-size: 100%;
    box-shadow: 0 2px 1px rgba(0, 0, 0, 0.04);
    height: 28px;
    padding: 0 10px;
    line-height: 26px;
    transition: border-color 0.15s, box-shadow 0.15s;
    cursor: pointer;
  }

    .jsr-btn:hover {
      box-shadow: 0 2px 1px rgba(0, 0, 0, 0.1);
      border-color: rgb(165, 159, 174);
      color: rgb(47, 41, 54);
    }

    .jsr-btn:focus,
    .jsr-btn:active {
      outline: none;
    }

  .jsreports-designer .select2-container.jsr-select2-error a.select2-choice {
    box-shadow: 0 0 1px 2px orange;
  }

  .jsr-btn.btn-success {
    background: #5cb85c;
    border-color: #5cb85c;
    color: white;
  }

  .jsr-select2-dropdown .select2-results {
    padding: 0;
    margin: 4px 0;
  }

    .jsr-select2-dropdown .select2-results .select2-highlighted {
      background: rgb(255,224,178);
      color: black;
    }

  .jsreports-designer .preview-element.jsr-element-adding {
    box-shadow: 0 0 30px rgba(243,156,18, 0);
    transition: background 1s, box-shadow 1s, transform 0.3s;
    background-color: transparent;
    transform: scale(1);
  }

  .jsreports-designer .preview-element.jsr-element-added {
    background-color: rgba(243,156,18, 0.3);
    box-shadow: 0 0 1px rgba(243,156,18, 1);
    transform: scale(0.8);
  }

  .jsr-settings-panel .default-font-size {
    padding-top: 5px;
  }

  .jsr-section-toolbar-item {
    margin: 0 5px;
  }

  .jsr-section-highlight {
    position: absolute;
    box-shadow: 0 0 0 6px rgba(33,150,243,0.2);
    display: none;
    border-radius: 0;
  }

  .jsr-toolbar.jsr-toolbar-docked.tool-container.tool-bottom .tool-item.jsr-section-toolbar-item button {
    height: 22px;
    font-size: 13px;
    line-height: 19px;
  }

  .jsr-text.jsr-text-rotate--90 {
    transform: rotate(-90deg);
    transform-origin: 0 0;
  }

  .jsreports-designer .preview-element .jsr-text.jsr-text-rotate--90 {
    top: 100%;
  }

  .jsr-text.jsr-text-rotate-90 {
    transform: rotate(90deg);
    transform-origin: 0 0;
  }

  .jsreports-designer .preview-element .jsr-text.jsr-text-rotate-90 {
    left: 100%;
  }

  .jsr-designer-zoom {
    border-radius: 5px;
    position: absolute;
    z-index: 100;
    top: 10px;
    right: 20px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0,0,0,0.2);
    opacity: 0.5;
    transition: opacity 0.2s;
    user-select: none;
  }

    .jsr-designer-zoom:hover {
      opacity: 1;
    }

    .jsr-designer-zoom > div {
      display: inline-block;
      width: 28px;
      height: 24px;
      font-size: 20px;
      font-weight: bold;
      line-height: 24px;
      text-align: center;
      color: #aaa;
      background: #f0f0f0;
      transition: background 0.2s, color 0.2s;
      cursor: pointer;
      border-right: 1px solid #ddd;
    }

      .jsr-designer-zoom > div:last-child {
        border-right: none;
      }

      .jsr-designer-zoom > div:hover {
        color: black;
        background: white;
      }

  .jsr-zoom-min .jsr-designer-zoom .jsr-designer-zoom-out,
  .jsr-zoom-min .jsr-designer-zoom .jsr-designer-zoom-out:hover,
  .jsr-zoom-max .jsr-designer-zoom .jsr-designer-zoom-in,
  .jsr-zoom-max .jsr-designer-zoom .jsr-designer-zoom-in:hover {
    cursor: default;
    color: #aaa;
    background: #f0f0f0;
  }


  .resizer {
    touch-action: none;
    position: absolute;
    box-sizing: border-box;
  }

    .resizer .active {
      background-color: rgba(255,255,0,0.2);
    }

  .handle {
    box-sizing: border-box;
    position: absolute;
    width: 10px;
    height: 10px;
    background: #EEE;
    border: 1px solid #333;
  }

  .handle-tl {
    top: -10px;
    left: -10px;
    cursor: nw-resize;
  }

  .handle-tm {
    top: -10px;
    left: 50%;
    margin-left: -5px;
    cursor: n-resize;
  }

  .handle-tr {
    top: -10px;
    right: -10px;
    cursor: ne-resize;
  }

  .handle-ml {
    top: 50%;
    margin-top: -5px;
    left: -10px;
    cursor: w-resize;
  }

  .handle-mr {
    top: 50%;
    margin-top: -5px;
    right: -10px;
    cursor: e-resize;
  }

  .handle-bl {
    bottom: -10px;
    left: -10px;
    cursor: sw-resize;
  }

  .handle-bm {
    bottom: -10px;
    left: 50%;
    margin-left: -5px;
    cursor: s-resize;
  }

  .handle-br {
    bottom: -10px;
    right: -10px;
    cursor: se-resize;
  }

  @media only screen and (max-width: 768px) {
    [class*="handle-"]:before {
      content: '';
      left: -10px;
      right: -10px;
      bottom: -10px;
      top: -10px;
      position: absolute;
    }
  }
</style>



// WEBPACK FOOTER //
// ReportEditorAdmin.vue?12d390a3